import React from "react"
export function OfficeContent(props) {
  switch (props.city) {
    case "Bengaluru":
      return (
        <div className="col-md-12">
          <h3 style={{ fontWeight: "bold" }}>Office Spaces in Bengaluru</h3>
          <p>
            Bengaluru, also known as the Silicon Valley of India, is a top
            destination for businesses seeking collaborative working spaces and
            scalable office rental solutions. Known for its robust startup
            ecosystem, global IT parks, and business-friendly infrastructure,
            the demand for flexible office space in Bengaluru continues to
            surge.
          </p>
          <p>
            From high-end tech parks to budget-friendly communal workspace
            environments, Bengaluru offers diverse office space TO LET options
            for businesses of every size. Whether you're a solopreneur or part
            of a 500-member enterprise, GoFloaters connects you to verified and
            adaptable office space for rent across Bengaluru.
          </p>
          <br />
          <h4 style={{ fontWeight: "bold" }}>Top Office Spaces in Bengaluru</h4>
          <p>
            <strong>1. WeWork Galaxy - Residency Road</strong>
            <br />
            One of Bengaluru's most iconic coworking spaces with modern
            amenities, a rooftop pool, event spaces, and private cabins. Pricing
            starts at ₹14,000/month.
          </p>
          <p>
            <strong>2. BHIVE Workspace - HSR Layout</strong>
            <br />
            Perfect for startups and freelancers, BHIVE offers collaborative
            working spaces at ₹6,000/month. Includes meeting rooms, ergonomic
            furniture, and community events.
          </p>
          <p>
            <strong>3. Awfis - Koramangala 5th Block</strong>
            <br />
            Located in a startup hotspot, this coworking space offers flexible
            desks and private offices starting at ₹8,500/month. Great for
            networking.
          </p>
          <p>
            <strong>4. Indiqube - Bellandur</strong>
            <br />A managed office provider known for premium private cabins and
            collaborative zones. Pricing begins at ₹9,500/month with high-speed
            internet, cafeteria, and 24/7 access.
          </p>
          <p>
            <strong>5. 91springboard - JP Nagar</strong>
            <br />A vibrant communal working space that offers a
            startup-friendly environment at ₹7,000/month. Includes tech-enabled
            meeting rooms, printing, and coffee stations.
          </p>
          <p>
            <strong>6. Cowrks - Ecoworld, ORR</strong>
            <br />
            Premium commercial space in one of Bengaluru&rsquo;s largest IT
            parks. Designed for large teams, prices start from ₹15,000/month.
          </p>
          <p>
            <strong>7. Innov8 - Koramangala</strong>
            <br />
            Beautifully designed workspace suited for creators and startups.
            Amenities include gaming zones, breakout areas, and ergonomic setups
            starting at ₹10,000/month.
          </p>
          <br />
          <h4 style={{ fontWeight: "bold" }}>
            Common Questions on Coworking Spaces in Bengaluru
          </h4>
          <p>
            <strong>
              Q1: What&rsquo;s the average cost of a coworking space in
              Bengaluru?
            </strong>
            <br />
            A1: The typical range is from ₹4,000 to ₹30,000 per seat/month,
            depending on locality and facilities.
          </p>
          <p>
            <strong>
              Q2: Can I find private offices inside communal working spaces?
            </strong>
            <br />
            A2: Yes, GoFloaters lists several coworking options that include
            lockable private offices within a shared office environment.
          </p>
          <p>
            <strong>
              Q3: Do collaborative working spaces in Bengaluru support larger
              teams?
            </strong>
            <br />
            A3: Many coworking hubs offer managed office solutions and
            enterprise-level seating for teams up to 500 members.
          </p>
          <p>
            <strong>Q4: What amenities do coworking spaces provide?</strong>
            <br />
            A4: Essentials include Wi-Fi, printing, power backup, air
            conditioning, event spaces, lounges, and refreshments.
          </p>
          <p>
            <strong>Q5: Are taxes like GST included in coworking rent?</strong>
            <br />
            A5: Generally, GST is applied on top of the base rent. GoFloaters
            ensures full pricing transparency upfront.
          </p>
          <br />
          <h4 style={{ fontWeight: "bold" }}>
            Best Locations for Office Spaces in Bengaluru
          </h4>
          <ul>
            <li>
              <p>
                <strong>Office spaces in Koramangala</strong> – Startup central
                with access to tech talent and vibrant nightlife.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Office spaces in </strong>HSR Layout
                </strong>
                 – Popular among tech and creative professionals for its
                peaceful layout and coworking ecosystem.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Office spaces in </strong>Indiranagar
                </strong>
                 – Ideal for businesses seeking a premium address with cultural
                vibe.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Office spaces in </strong>Whitefield
                </strong>
                 – A major IT hub, perfect for large teams and enterprises.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Office spaces in </strong>Bellandur &amp; 
                </strong>
                <strong>Office spaces in </strong>
                <strong>ORR (Outer Ring Road)</strong> – Close to corporate
                headquarters and tech parks.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Office spaces in </strong>Jayanagar &amp; 
                </strong>
                <strong>Office spaces in </strong>
                <strong>JP Nagar</strong> – Established residential-business
                mix, good for consultants and agencies.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Office spaces in </strong>Hebbal &amp; 
                </strong>
                <strong>Office spaces in </strong>
                <strong>Yelahanka</strong> – Emerging areas with affordable
                office rental spaces.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Office spaces in </strong>MG Road &amp; 
                </strong>
                <strong>Office spaces in </strong>
                <strong>Residency Road</strong> – Prime CBD locations with metro
                access and high-end buildings.
              </p>
            </li>
          </ul>
          <br />
          <h4 style={{ fontWeight: "bold" }}>Top Tech Parks in Bengaluru</h4>
          <ul>
            <li>
              <p>Bagmane Tech Park</p>
            </li>
            <li>
              <p>Manyata Tech Park</p>
            </li>
            <li>
              <p>Embassy Tech Village</p>
            </li>
            <li>
              <p>RMZ Ecoworld</p>
            </li>
            <li>
              <p>Ecospace Business Park</p>
            </li>
            <li>
              <p>Global Technology Park</p>
            </li>
            <li>
              <p>Prestige Tech Park</p>
            </li>
            <li>
              <p>ITPL (International Tech Park Limited), Whitefield</p>
            </li>
            <li>
              <p>Pritech Park SEZ</p>
            </li>
            <li>
              <p>Embassy Golf Links Business Park</p>
            </li>
          </ul>
          <p>
            These campuses host global MNCs, startups, and collaborative working
            spaces with top-tier infrastructure.
          </p>
          <br />
          <h4 style={{ fontWeight: "bold" }}>
            Popular Coworking Locations in Bengaluru
          </h4>
          <p>
            Explore communal workspace options across these top neighborhoods:
          </p>
          <ul>
            <li>
              <p>
                <strong>Coworking spaces in Koramangala</strong> – Trendy and
                packed with startups.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Coworking spaces in </strong>Indiranagar
                </strong>
                 – Premium, stylish, and walkable.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Coworking spaces in </strong>Whitefield
                </strong>
                 – Tech zone with coworking near global HQs.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Coworking spaces in </strong>Bellandur/ORR
                </strong>
                 – Corporate-friendly, easily accessible.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Coworking spaces in </strong>HSR Layout
                </strong>
                 – Peaceful and affordable.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Coworking spaces in </strong>JP Nagar &amp; Jayanagar
                </strong>
                 – Balanced lifestyle with client-friendly setups.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Coworking spaces in </strong>MG Road
                </strong>
                 – Central Business District with heritage and class.
              </p>
            </li>
          </ul>
          <br />
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters for Office Spaces in Bengaluru?
          </h4>
          <ul>
            <li>
              <p>
                <strong>Transparent Pricing</strong> – Clear rentals with no
                surprises.
              </p>
            </li>
            <li>
              <p>
                <strong>Prime Inventory</strong> – Listings in all major
                business hubs of Bengaluru.
              </p>
            </li>
            <li>
              <p>
                <strong>Flexible Options</strong> – Hourly, daily, and monthly
                bookings.
              </p>
            </li>
            <li>
              <p>
                <strong>Scalable Workspaces</strong> – Designed for teams of all
                sizes.
              </p>
            </li>
            <li>
              <p>
                <strong>Verified Amenities</strong> – Everything from internet
                to power backup to snacks.
              </p>
            </li>
          </ul>
          <p>
            Whether you&rsquo;re a freelancer, founder, or enterprise leader,
            GoFloaters is your go-to platform to discover office space for rent
            in Bengaluru that fits your budget, team size, and location
            preference.
          </p>
        </div>
      )
    case "Chennai":
      return (
        <div className="col-md-12">
          <h3 style={{ fontWeight: "bold" }}>Office Spaces in Chennai</h3>
          <p>
            Chennai, a bustling hub of commerce, technology, and culture, has
            witnessed a surge in demand for flexible office spaces. As a city
            known for its vibrant IT and business ecosystem, Chennai attracts
            startups, SMEs, and global corporations alike. The availability of
            modern and versatile office spaces plays a pivotal role in
            accommodating this dynamic growth.
          </p>
          <p>
            From coworking hubs to managed offices, these spaces are designed to
            cater to a variety of business needs, offering facilities like
            high-speed internet, conference rooms, and ergonomic workstations.
            Whether you’re an entrepreneur looking to scale or a corporation
            establishing a presence, Chennai’s flexible office spaces offer the
            ideal solution to foster productivity and innovation.
          </p>
          <br></br>
          <h4 style={{ fontWeight: "bold" }}>
            Top Office Space Locations in Chennai
          </h4>{" "}
          <p>
            <strong>1. Awfis Spero Primus - Guindy</strong>
            <br />A vibrant coworking space in the prime business hub of Guindy,
            offering fully equipped offices at ₹9,000/month. With easy metro
            access, collaborative zones, and dedicated workspaces, it caters to
            professionals seeking convenience and flexibility.
          </p>
          <p>
            <strong>2. WeWork Olympia Cyberspace - Guindy</strong>
            <br />
            Situated in the renowned tech park community, WeWork Olympia
            Cyberspace offers premium office solutions starting at
            ₹18,000/month. With top-tier facilities like desks, meeting rooms,
            and private cabins, it’s tailored for businesses seeking a
            professional environment.
          </p>
          <p>
            <strong>3. Awfis Prestige Palladium Bayan - Nungambakkam</strong>
            <br />
            Offering a range of workspace options, including shared desks and
            dedicated cabins, this space starts at ₹8,999/month. Located in a
            central area with access to major transport links, Awfis provides a
            vibrant and collaborative atmosphere for teams of all sizes.
          </p>
          <p>
            <strong>4. Smartworks Arihant Verge - Perungudi</strong>
            <br />
            Perfect for mid-size to large teams, this managed office space
            provides ergonomic furniture, high-speed internet, and breakout
            areas starting at ₹10,499/month. Its location in the fast-growing
            business hub of Perungudi makes it a strategic choice for expanding
            businesses.
          </p>
          <p>
            <strong>5. Innov8 SKCL Techsquare - Guindy</strong>
            <br />
            Situated in Chennai’s rapidly developing IT hub, this coworking
            space provides cost-effective office solutions at ₹10,499/month.
            It’s equipped with high-speed internet, meeting rooms, and
            collaborative zones for teams looking for a modern work environment.
          </p>
          <p>
            <strong>6. Indiqube Brigade Vantage - Perungudi</strong>
            <br />
            Known for its prime location, Indiqube offers premium private cabins
            and shared workspaces starting at ₹7,500/month. With personalized
            services and networking opportunities, it’s ideal for professionals
            and SMEs.
          </p>
          <p>
            <strong>7. The Executive Zone - Anna Salai</strong>
            <br />A luxurious coworking space offering exclusive office setups
            at ₹9,000/month. Located in one of Chennai’s most prestigious areas,
            it features state-of-the-art meeting rooms, concierge services, and
            24/7 access.
          </p>
          <br />
          <br />
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters to book your office space in Chennai
          </h4>
          <p>
            GoFloaters has been in the space of helping individuals and teams
            find flexible and affordable workspaces for over 3 years now.
            GoFloaters was started with a vision to help anyone get an office
            space when they want, where they want and within their budget. We
            set out to build office spaces for a distributed world where
            individuals and teams should be able to work near home.&nbsp;
          </p>
          <br />
          <p>
            Following are the advantages of booking coworking spaces and meeting
            spaces on the GoFloaters app:
          </p>
          <ul>
            <li>
              <p>
                <strong>Work Near Home :</strong> In most of the cities that we
                serve you can get a space within 5 kms of your home or wherever
                you are
              </p>
            </li>
            <li>
              <p>
                <strong>Pay-per-use : </strong>You can book coworking spaces on
                a daily basis and meeting spaces on an hourly basis and pay only
                for the time you have used it.
              </p>
            </li>
            <li>
              <p>
                <strong>No contracts :</strong> You don&rsquo;t have to sign any
                kind of contracts with us.&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Cost effective :</strong> We have negotiated heavily
                with our space partners to bring you savings of at least 20% if
                not more on the day pass rates and the meeting room rents.
              </p>
            </li>
            <li>
              <p>
                <strong>Instant Bookings : </strong>No need to call anyone or
                email anyone to check space availability. You can book coworking
                spaces instantaneously. Meeting spaces just need 30 mins of time
                for confirmation.&nbsp;&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Community Perks :</strong> GoFloaters has partnered with
                over 65+ companies to bring you over Rs 1 Crore of benefits to
                you.
              </p>
            </li>
          </ul>
          <h4 style={{ fontWeight: "bold" }}>
            Common Questions on Coworking Spaces in Chennai
          </h4>
          <p>
            <strong>
              Q1: What&rsquo;s the average cost of a coworking space in Chennai?
            </strong>
            <br />
            A1: Prices range from INR 2,000 to INR 25,000 per seat per month
            depending on location and features.
          </p>
          <p>
            <strong>
              Q2: Can I find private offices inside communal working spaces?
            </strong>
            <br />
            A2: Yes, GoFloaters offers coworking space Chennai options that
            include private cabins for teams that need focus along with shared
            access to amenities.
          </p>
          <p>
            <strong>Q3: Do communal workspaces support larger teams?</strong>
            A3: Absolutely. Many collaborative working spaces on GoFloaters can
            be scaled for teams up to 200+ employees.
          </p>
          <p>
            <strong>
              Q4: What amenities are available in coworking spaces?
            </strong>
            <br />
            A4: High-speed internet, conference rooms, ergonomic furniture,
            break areas, pantry, printing services, and community events.
          </p>
          <p>
            <strong>Q5: Are taxes like GST included in the rent?</strong>
            <br />
            A5: GST is usually charged separately, but GoFloaters ensures full
            transparency on pricing and tax inclusions.
          </p>
          <br />
          <h4 style={{ fontWeight: "bold" }}>
            Best Locations for Office Spaces in Chennai
          </h4>
          <p>
            The right location adds value to your operations. Here are
            Chennai&rsquo;s best neighborhoods for office space:
          </p>
          <ol start="1" style={{ paddingLeft: "35px" }}>
            <li>
              <p>
                <strong>Guindy</strong> – Central location, metro access, and
                corporate parks.
              </p>
            </li>
            <li>
              <p>
                <strong>OMR</strong> – Hub for IT companies and startups, lined
                with tech corridors.
              </p>
            </li>
            <li>
              <p>
                <strong>Perungudi</strong> – Growing business district with
                budget-friendly options.
              </p>
            </li>
            <li>
              <p>
                <strong>Nungambakkam</strong> – Premium location, suitable for
                client-facing businesses.
              </p>
            </li>
            <li>
              <p>
                <strong>T. Nagar</strong> – Well-connected, bustling commercial
                zone.
              </p>
            </li>
            <li>
              <p>
                <strong>Anna Nagar</strong> – Balanced ecosystem for small
                businesses and creatives.
              </p>
            </li>
            <li>
              <p>
                <strong>Sholinganallur</strong> – Emerging tech hub with modern
                business infrastructure.
              </p>
            </li>
            <li>
              <p>
                <strong>Velachery</strong> – Great for mid-sized teams, good
                transport, and amenities.
              </p>
            </li>
            <li>
              <p>
                <strong>Adyar</strong> – Ideal for individual professionals and
                consultants.
              </p>
            </li>
            <li>
              <p>
                <strong>Alwarpet</strong> – Prestigious locality for businesses
                valuing legacy and location.
              </p>
            </li>
          </ol>
          <br />
          <h4 style={{ fontWeight: "bold" }}>Top Tech Parks in Chennai</h4>
          <p>
            Explore collaborative working spaces inside Chennai&rsquo;s biggest
            tech parks:
          </p>
          <ul>
            <li>
              <p>Tidel Park, Taramani</p>
            </li>
            <li>
              <p>Olympia Tech Park, Guindy</p>
            </li>
            <li>
              <p>DLF Cybercity, Manapakkam</p>
            </li>
            <li>
              <p>Ramanujan IT City, Taramani</p>
            </li>
            <li>
              <p>Ascendas IT Park (ITPB), Taramani</p>
            </li>
            <li>
              <p>SP Infocity, Perungudi</p>
            </li>
            <li>
              <p>SIPCOT IT Park, Siruseri</p>
            </li>
            <li>
              <p>One India Bulls Park, Ambattur</p>
            </li>
            <li>
              <p>Prince Infocity, Perungudi</p>
            </li>
            <li>
              <p>L&amp;T Estancia SEZ, Guduvanchery</p>
            </li>
            <li>
              <p>TECCI Park, Sholinganallur</p>
            </li>
            <li>
              <p>Futura Tech Park, Sholinganallur</p>
            </li>
          </ul>
          <p>
            These parks host global firms and provide robust infrastructure,
            making them perfect for setting up office rental spaces in Chennai.
          </p>
          <br />
          <h4 style={{ fontWeight: "bold" }}>
            Popular Coworking Locations in Chennai
          </h4>
          <p>
            Explore communal workspace options across these popular
            neighborhoods:
          </p>
          <ul>
            <li>
              <p>
                <strong>Guindy:</strong> Premium Chennai co working space
                options, easy commute, tech parks.
              </p>
            </li>
            <li>
              <p>
                <strong>OMR:</strong> Vibrant startup zone with several shared
                office space providers.
              </p>
            </li>
            <li>
              <p>
                <strong>Perungudi:</strong> Affordable for growing businesses.
              </p>
            </li>
            <li>
              <p>
                <strong>Sholinganallur:</strong> Tech-focused crowd and new-gen
                amenities.
              </p>
            </li>
            <li>
              <p>
                <strong>Nungambakkam:</strong> Suitable for businesses looking
                for prestige and proximity.
              </p>
            </li>
            <li>
              <p>
                <strong>Anna Nagar &amp; T. Nagar:</strong> Balanced lifestyle
                with access to client networks.
              </p>
            </li>
            <li>
              <p>
                <strong>Velachery:</strong> Mid-budget options with full service
                facilities.
              </p>
            </li>
            <li>
              <p>
                <strong>Adyar, Alwarpet, Egmore, Royapettah:</strong> Ideal for
                freelancers and small teams.
              </p>
            </li>
          </ul>
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters for Office Spaces in Chennai?
          </h4>
          <ul>
            <li>
              <p>
                <strong>Transparent Pricing</strong>: Detailed pricing ensures
                clarity, allowing businesses to choose spaces within their
                budget.
              </p>
            </li>
            <li>
              <p>
                <strong>Customizable Options</strong>: From short-term to
                long-term setups, GoFloaters offers flexible plans that adapt to
                your requirements.
              </p>
            </li>
            <li>
              <p>
                <strong>Prime Locations</strong>: With offices across
                Chennai&rsquo;s key business hubs, you&rsquo;re guaranteed
                accessibility and convenience.
              </p>
            </li>
            <li>
              <p>
                <strong>Ease of Booking</strong>: The user-friendly platform
                makes it easy to compare, book, and manage office spaces in just
                a few clicks.
              </p>
            </li>
          </ul>
          <p>
            Whether you're a freelancer, startup, or established corporation,
            GoFloaters is your trusted partner in finding the perfect office
            space to fuel your growth in Chennai.
          </p>
        </div>
      )
    case "Lucknow":
      return (
        <div className="col-md-12">
          <h2 style={{ fontWeight: "bold" }}>
            Dive into Prime Shared Office Spaces in Lucknow
          </h2>
          <p>
            Cultural Heartbeat - Renowned Education Hubs - Picturesque
            Attractions - Historical Landmarks - Vibrant Social Life. Lucknow,
            with its unique blend of tradition and modernity, has been a magnet
            for growth and development, especially in the last decade.
            <br />
            <br />
            While the city preserves its historical significance, it's making
            waves in areas such as IT, retail, and more. As infrastructure and
            businesses bloom, many enterprises are steering away from
            conventional office setups in the 'City of Nawabs'.
            <br />
            <br />
            The contemporary solution? Co-working! Recent years have seen a
            spike in co-working establishments in Lucknow, with spaces like
            CoNexus, Work Studio, and Innov8 marking their presence.
            Entrepreneurs in Lucknow now have the luxury of choice, with a
            spectrum of spaces tailored to diverse needs.
            <br />
            <br />
            But it's not just about a desk and a chair. These co-working hubs in
            Lucknow also provide meeting rooms and office spaces available for
            monthly rent, making it easier for businesses to adapt and grow.
            <br />
            <br />
            Discover the myriad of shared office opportunities Lucknow offers,
            exclusively on GoFloaters.com.
            <br />
            <br />
          </p>
        </div>
      )
    case "Hyderabad":
      return (
        <div className="col-md-12">
          <h4 style={{ fontWeight: "bold" }}> Office Spaces in Hyderabad</h4>
          <p>
            Hyderabad, a leading IT and pharmaceutical hub, has emerged as a
            prime destination for businesses seeking flexible office space. With
            the rise of startups and MNCs, the city offers everything from
            affordable communal workspace setups to premium managed office
            spaces across its commercial zones.
          </p>
          <p>
            Whether you&rsquo;re looking for a compact office space TO LET in
            HITEC City or a spacious collaborative working space in Banjara
            Hills, GoFloaters connects you to the most relevant and
            ready-to-move-in options. The city&rsquo;s pro-business environment,
            strong infrastructure, and expanding metro make Hyderabad an ideal
            destination for office space for rent.
          </p>
          <br />
          <h4 style={{ fontWeight: "bold" }}>
            {" "}
            Top Office Spaces in Hyderabad
          </h4>
          <p>
            <strong>1. WeWork - RMZ Spire, HITEC City</strong>
            <br />
            Premium coworking space in Hyderabad's tech corridor. Offers desks,
            meeting rooms, event areas, and wellness zones. Starts at
            ₹13,000/month.
          </p>
          <p>
            <strong>2. iSprout Business Centre - Madhapur</strong>
            <br />
            Vibrant communal workspace with high-end amenities including gaming
            zones and event spaces. Prices from ₹7,500/month.
          </p>
          <p>
            <strong>3. Awfis - Gachibowli</strong>
            <br />
            Flexible workspaces and meeting rooms with high-speed internet and
            ergonomic furniture starting at ₹8,000/month. Ideal for tech
            startups and consultants.
          </p>
          <p>
            <strong>4. Smartworks - A3 Knowledge City, HITEC City</strong>
            <br />
            Fully serviced managed offices perfect for teams of 20–200+,
            offering enterprise-grade security, customizable interiors, and 24/7
            access. Starts at ₹9,999/month.
          </p>
          <p>
            <strong>5. IndiQube - Western Aqua, Kondapur</strong>
            <br />
            Hybrid of coworking and private office solutions. Offers pantry,
            recreation areas, and phone booths. Prices begin at ₹9,000/month.
          </p>
          <p>
            <strong>6. Regus - SLN Terminus, Gachibowli</strong>
            <br />
            Ideal for professionals looking for a premium business address with
            flexible plans. Pricing starts at ₹12,000/month.
          </p>
          <p>
            <strong>7. The Office Pass - Banjara Hills</strong>
            <br />
            Quiet, professional environment ideal for solopreneurs and remote
            teams. Desk rates from ₹6,000/month.
          </p>
          <br />
          <h4 style={{ fontWeight: "bold" }}>
            {" "}
            Common Questions on Coworking Spaces in Hyderabad
          </h4>
          <p>
            <strong>
              Q1: What&rsquo;s the average cost of a coworking space in
              Hyderabad?
            </strong>
            <br />
            A1: ₹3,500 to ₹22,000/month per seat depending on the location and
            amenities.
          </p>
          <p>
            <strong>
              Q2: Can I find private offices inside communal working spaces?
            </strong>
            <br />
            A2: Yes. Many coworking hubs on GoFloaters offer private cabins
            within larger shared office layouts.
          </p>
          <p>
            <strong>
              Q3: Are collaborative working spaces suitable for large teams?
            </strong>
            <br />
            A3: Definitely. GoFloaters partners with providers who cater to
            teams of up to 300+ members in managed or modular layouts.
          </p>
          <p>
            <strong>
              Q4: What amenities can I expect in Hyderabad coworking spaces?
            </strong>
            <br />
            A4: Standard amenities include fast internet, ergonomic chairs, AC,
            pantry, printer access, meeting rooms, and breakout areas.
          </p>
          <p>
            <strong>
              Q5: Are GST and service charges included in the price?
            </strong>
            <br />
            A5: Generally, GST is additional. All pricing on GoFloaters is
            clearly itemized for transparency.
          </p>
          <br />
          <h4 style={{ fontWeight: "bold" }}>
            {" "}
            Best Locations for Office Spaces in Hyderabad
          </h4>
          <ul>
            <li>
              <p>
                <strong>Office Spaces in HITEC City</strong> – Premier tech hub
                with world-class business infrastructure.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Office Spaces in </strong>Madhapur
                </strong>
                 – Startup favorite with modern coworking setups.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Office Spaces in </strong>Gachibowli
                </strong>
                 – Ideal for IT and finance companies.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Office Spaces in </strong>Kondapur
                </strong>
                 – Mid-budget zone with excellent accessibility.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Office Spaces in </strong>Banjara Hills
                </strong>
                 – Premium locale for consulting firms and creative agencies.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Office Spaces in </strong>Jubilee Hills
                </strong>
                 – Blend of lifestyle and professional zones.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Office Spaces in </strong>Begumpet
                </strong>
                 – Centrally located with solid transport links.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Office Spaces in </strong>Ameerpet
                </strong>
                 – Affordable for training institutes and small consultancies.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Office Spaces in </strong>Uppal &amp; 
                </strong>
                <strong>Office Spaces in </strong>
                <strong>LB Nagar</strong> – Emerging business zones with value
                rentals.
              </p>
            </li>
          </ul>
          <br />
          <h4 style={{ fontWeight: "bold" }}> Top Tech Parks in Hyderabad</h4>
          <ul>
            <li>
              <p>Mindspace IT Park</p>
            </li>
            <li>
              <p>Cyber Pearl</p>
            </li>
            <li>
              <p>Ascendas IT Park</p>
            </li>
            <li>
              <p>Raheja Mindspace SEZ</p>
            </li>
            <li>
              <p>Divyasree Omega</p>
            </li>
            <li>
              <p>Knowledge City</p>
            </li>
            <li>
              <p>The V IT Park</p>
            </li>
            <li>
              <p>GMR AeroCity</p>
            </li>
            <li>
              <p>Phoenix Avance Business Hub</p>
            </li>
            <li>
              <p>RMZ Futura</p>
            </li>
          </ul>
          <p>
            These parks offer Grade A office space, top-notch facilities, and
            excellent ecosystem support for tech and service-based businesses.
          </p>
          <br />
          <h4 style={{ fontWeight: "bold" }}>
            {" "}
            Popular Coworking Locations in Hyderabad
          </h4>
          <ul>
            <li>
              <p>
                <strong>Coworking Spaces in HITEC City</strong> – Access to tech
                talent and robust infrastructure.
              </p>
            </li>
            <li>
              <p>
                <strong>Coworking </strong>
                <strong>Spaces </strong>
                <strong>in Madhapur</strong> – Trendy, youthful, and innovative.
              </p>
            </li>
            <li>
              <p>
                <strong>Coworking </strong>
                <strong>Spaces</strong>
                <strong> in Gachibowli</strong> – Suited for enterprises and
                R&amp;D units.
              </p>
            </li>
            <li>
              <p>
                <strong>Coworking </strong>
                <strong>Spaces </strong>
                <strong>in Kondapur</strong> – Affordable yet connected.
              </p>
            </li>
            <li>
              <p>
                <strong>Coworking </strong>
                <strong>Spaces </strong>
                <strong>in Banjara Hills &amp; Coworking </strong>
                <strong>Spaces in </strong>
                <strong>Jubilee Hills</strong> – Perfect for consultants and
                boutique firms.
              </p>
            </li>
            <li>
              <p>
                <strong>Coworking </strong>
                <strong>Spaces </strong>
                <strong>in Ameerpet &amp; Coworking Spaces in Begumpet</strong>
                 – Central and cost-effective.
              </p>
            </li>
          </ul>
          <br />
          <h4 style={{ fontWeight: "bold" }}>
            {" "}
            Why Choose GoFloaters for Office Spaces in Hyderabad?
          </h4>
          <ul>
            <li>
              <p>
                <strong>Transparent Rentals</strong> – Real prices with no
                hidden costs.
              </p>
            </li>
            <li>
              <p>
                <strong>Flexible Leases</strong> – From hourly to yearly, you
                pick the plan.
              </p>
            </li>
            <li>
              <p>
                <strong>Prime Inventory</strong> – Spaces listed across
                Hyderabad&rsquo;s major localities.
              </p>
            </li>
            <li>
              <p>
                <strong>Scalable Solutions</strong> – Grow your office as your
                team grows.
              </p>
            </li>
            <li>
              <p>
                <strong>Verified Listings</strong> – Fully vetted office spaces
                with actual images.
              </p>
            </li>
          </ul>
          <p>
            From freelancers to enterprises, GoFloaters is the most reliable
            platform to find office space for rent in Hyderabad—whether you need
            a single desk or an entire floor.
          </p>
        </div>
      )
    case "Mumbai":
      return (
        <div className="col-md-12">
          <h3 style={{ fontWeight: "bold" }}>Office Spaces in Mumbai</h3>
          <p>
            Mumbai is India&rsquo;s financial capital and a hotspot for
            enterprise headquarters, creative studios, startups, and consulting
            firms. With rising demand for hybrid and flexible work setups, the
            city has embraced communal workspaces, collaborative zones, and
            fully-managed offices.
          </p>
          <p>
            From Nariman Point to Powai, Mumbai offers office space TO LET that
            suits freelancers, agile startups, and multinational corporations.
            GoFloaters helps you access fully verified office space for rent in
            Mumbai that meets your operational and cultural goals.
          </p>
          <br />
          <h3 style={{ fontWeight: "bold" }}>Top Office Spaces in Mumbai</h3>
          <p>
            <strong>1. WeWork - BKC</strong>
            <br />
            Premium coworking space in Mumbai&rsquo;s key business district.
            Offers private offices, lounges, event spaces. Starts at
            ₹15,000/month.
          </p>
          <p>
            <strong>2. Awfis - Andheri East</strong>
            <br />
            Well-connected workspace offering private cabins and shared desks.
            Ideal for mid-sized teams. Starts at ₹9,000/month.
          </p>
          <p>
            <strong>3. 91springboard - Vikhroli</strong>
            <br />
            Dynamic coworking environment with flexible pricing and mentorship
            access. Prices from ₹7,500/month.
          </p>
          <p>
            <strong>4. Innov8 - Kurla</strong>
            <br />
            Creative communal workspace offering breakout zones, ergonomic
            seating, and community access. Starts at ₹10,000/month.
          </p>
          <p>
            <strong>5. Regus - Nariman Point</strong>
            <br />
            Corporate-style managed offices for consultants and MNCs. Starting
            from ₹18,000/month.
          </p>
          <p>
            <strong>6. WorkAmp - Lower Parel</strong>
            <br />
            Flexible, industrial-style office rental spaces for tech teams and
            creative agencies. Pricing from ₹12,000/month.
          </p>
          <p>
            <strong>7. IndiQube - Malad</strong>
            <br />
            Premium plug-and-play offices with enterprise-grade infrastructure.
            Starting at ₹10,000/month.
          </p>
          <br />
          <h3 style={{ fontWeight: "bold" }}>
            Common Questions on Coworking Spaces in Mumbai
          </h3>
          <p>
            <strong>
              Q1: What&rsquo;s the average cost of a coworking space in Mumbai?
            </strong>
            <br />
            A1: Prices typically range between ₹5,000 and ₹35,000 per
            seat/month, depending on the neighborhood and services provided.
          </p>
          <p>
            <strong>
              Q2: Can I get private offices inside coworking spaces in Mumbai?
            </strong>
            <br />
            A2: Yes. Most coworking hubs listed on GoFloaters offer private
            cabins and team rooms within shared premises.
          </p>
          <p>
            <strong>
              Q3: Do coworking spaces support hybrid and remote teams?
            </strong>
            <br />
            A3: Yes. You can choose flexible plans, rotating desk access, or
            private work pods ideal for hybrid setups.
          </p>
          <p>
            <strong>
              Q4: Are coworking spaces in Mumbai metro-accessible?
            </strong>
            <br />
            A4: Many workspaces are located near Mumbai Metro or local railway
            stations for ease of commute.
          </p>
          <p>
            <strong>Q5: Do coworking spaces provide parking?</strong>
            <br />
            A5: Several premium coworking spaces in Mumbai offer valet or
            reserved parking for members.
          </p>
          <p>
            <strong>Q6: What kind of amenities are typically included?</strong>
            <br />
            A6: High-speed internet, printers, AC, coffee/tea, pantry, meeting
            rooms, lounges, and event spaces are standard.
          </p>
          <p>
            <strong>
              Q7: Are there flexible plans like hourly or daily passes?
            </strong>
            <br />
            A7: Yes. Many providers on GoFloaters offer daily, hourly, and
            weekend access options.
          </p>
          <p>
            <strong>Q8: Is GST included in coworking prices?</strong>
            <br />
            A8: Usually, GST is charged separately. GoFloaters ensures price
            transparency upfront.
          </p>
          <br />
          <h3 style={{ fontWeight: "bold" }}>
            Best Locations for Office Spaces in Mumbai
          </h3>
          <ul>
            <li>
              <p>
                <strong>Office Spaces in BKC (Bandra Kurla Complex)</strong> –
                Financial hub, home to top corporates.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Office Spaces in </strong>Lower Parel
                </strong>
                 – Industrial-turned-commercial zone ideal for media &amp; tech
                firms.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Office Spaces in </strong>Andheri East &amp; West
                </strong>
                 – Versatile, affordable, and well-connected.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Office Spaces in </strong>Nariman Point
                </strong>
                 – Legacy business area with sea views and global presence.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Office Spaces in </strong>Powai
                </strong>
                 – Popular among startups and fintech.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Office Spaces in </strong>Vikhroli &amp; 
                </strong>
                <strong>Office Spaces in </strong>
                <strong>Kurla</strong> – Rising coworking zones with creative
                energy.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Office Spaces in </strong>Malad &amp; 
                </strong>
                <strong>Office Spaces in </strong>
                <strong>Goregaon</strong> – Ideal for media houses, tech firms,
                and remote teams.
              </p>
            </li>
          </ul>
          <br />
          <h3 style={{ fontWeight: "bold" }}>
            Top Commercial Parks and Business Hubs in Mumbai
          </h3>
          <ul>
            <li>
              <p>Bandra Kurla Complex (BKC)</p>
            </li>
            <li>
              <p>One BKC</p>
            </li>
            <li>
              <p>Mindspace Airoli</p>
            </li>
            <li>
              <p>Nirlon Knowledge Park, Goregaon</p>
            </li>
            <li>
              <p>Hiranandani Business Park, Powai</p>
            </li>
            <li>
              <p>Peninsula Corporate Park, Lower Parel</p>
            </li>
            <li>
              <p>Maker Chambers, Nariman Point</p>
            </li>
            <li>
              <p>Times Square, Andheri East</p>
            </li>
          </ul>
          <br />
          <h3 style={{ fontWeight: "bold" }}>
            Popular Coworking Locations in Mumbai
          </h3>
          <ul>
            <li>
              <p>
                <strong>Coworking Spaces in BKC</strong> – Ideal for finance,
                legal, and enterprise teams.
              </p>
            </li>
            <li>
              <p>
                <strong>Coworking </strong>
                <strong>Spaces </strong>
                <strong>in Andheri</strong> – High accessibility and wide
                variety of plans.
              </p>
            </li>
            <li>
              <p>
                <strong>Coworking </strong>
                <strong>Spaces </strong>
                <strong>in Lower Parel</strong> – Suited for creative, digital,
                and tech sectors.
              </p>
            </li>
            <li>
              <p>
                <strong>Coworking </strong>
                <strong>Spaces </strong>
                <strong>in Powai &amp; Coworking Spaces in Vikhroli</strong> –
                Affordable, vibrant startup culture.
              </p>
            </li>
            <li>
              <p>
                <strong>Coworking </strong>
                <strong>Spaces </strong>
                <strong>in Nariman Point</strong> – Premium office rentals with
                legacy value.
              </p>
            </li>
          </ul>
          <br />
          <h3 style={{ fontWeight: "bold" }}>
            Coworking Space Price in Mumbai
          </h3>
          <p>
            The cost of coworking space in Mumbai varies significantly based on
            the locality and services provided. Premium areas like BKC and
            Nariman Point attract higher rents, while locations like Andheri and
            Vikhroli offer economical yet functional workspaces.
          </p>
          <ul>
            <li>
              <p>
                <strong>Cost of Coworking Space in BKC:</strong> ₹15,000 to
                ₹35,000
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Cost of Coworking Space in </strong>Lower Parel:
                </strong>
                 ₹12,000 to ₹25,000
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Cost of Coworking Space in </strong>Nariman Point:
                </strong>
                 ₹18,000 to ₹35,000
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Cost of Coworking Space in </strong>Andheri (East
                  &amp; West):
                </strong>
                 ₹7,000 to ₹18,000
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Cost of Coworking Space in </strong>Powai:
                </strong>
                 ₹9,000 to ₹20,000
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Cost of Coworking Space in </strong>Kurla &amp; 
                </strong>
                <strong>Cost of Coworking Space in </strong>
                <strong>Vikhroli:</strong> ₹7,500 to ₹15,000
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Cost of Coworking Space in </strong>Malad &amp; 
                </strong>
                <strong>Cost of Coworking Space in </strong>
                <strong>Goregaon:</strong> ₹6,000 to ₹14,000
              </p>
            </li>
          </ul>
          <br />
          <h3 style={{ fontWeight: "bold" }}>
            Questions on Coworking in Mumbai
          </h3>
          <p>
            <strong>Q. Where can I find affordable coworking in Mumbai?</strong>
            <br />
            A. Areas like Goregaon, Malad, and Vikhroli offer budget-friendly
            coworking options with flexible terms.
          </p>
          <p>
            <strong>Q. Which coworking zones are close to Mumbai Metro?</strong>
            <br />
            A. Andheri, Lower Parel, Kurla, and Powai are well-connected via
            metro or local trains.
          </p>
          <p>
            <strong>Q. Are there coworking spaces near Mumbai Airport?</strong>
            <br />
            A. Yes, Andheri East and BKC are within short driving distance of
            the airport.
          </p>
          <p>
            <strong>
              Q. Can freelancers and creatives use coworking in Mumbai?
            </strong>
            <br />
            A. Absolutely. Many spaces cater to solo professionals with daily or
            part-time membership plans.
          </p>
          <p>
            <strong>
              Q. What is the cost of shared office space in Mumbai?
            </strong>
            <br />
            A. Shared office spaces typically range from ₹5,000 to ₹25,000 per
            seat/month based on location and amenities.
          </p>
          <br />
          <h3 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters for Office Spaces in Mumbai?
          </h3>
          <ul>
            <li>
              <p>
                <strong>Transparent Listings</strong> – See real photos,
                accurate prices, and actual availability.
              </p>
            </li>
            <li>
              <p>
                <strong>Flexible Terms</strong> – Book by the hour, day, or
                month—based on your team&rsquo;s need.
              </p>
            </li>
            <li>
              <p>
                <strong>Prime Locations</strong> – Access office space for rent
                in Mumbai&rsquo;s top commercial areas.
              </p>
            </li>
            <li>
              <p>
                <strong>Custom Solutions</strong> – Choose between coworking,
                managed offices, or hybrid workspaces.
              </p>
            </li>
            <li>
              <p>
                <strong>Verified Quality</strong> – Each space is vetted and
                compliant with business standards.
              </p>
            </li>
          </ul>
          <p>
            Whether you&rsquo;re a solo founder, creative agency, or enterprise
            team, GoFloaters is your trusted platform to find and book
            collaborative working spaces or private offices across Mumbai.
          </p>
        </div>
      )
    case "Pune":
      return (
        <div className="col-md-12">
          <h2 style={{ fontWeight: "bold" }}>
            Office Space in Pune, Best Deal in Town
          </h2>
          <p>
            An Easy Way To Find No Lock-in, Short Term Or Long Term Rental
            Private Office Space in Pune
            <br />
            <br />
            Long-term Work-from-Home has taken a toll on all of us. Due to the
            economic situations in the current years, companies have moved out
            of their permanent offices, headquarters, and long-term rented
            spaces. Business and start-ups are choosing to go on-demand,
            short-term or medium-term rental office space. Office spaces or hubs
            that can avoid long commutes and closer to the homes of team
            members.
            <br />
            <br />
            For freelancers and independent professionals’ home has been an
            office, but when the home is now housefull, you are bound to search
            for spaces that can be your office. Some teams are transitioning
            between old and new locations, and the uncertainty has challenged
            them with office-less situations.
            <br />
            <br />
            Whether it is for yourself, teams, or start-ups, these temporary
            office spaces closer to home or suburban locations are the best
            options. Private offices in coworking spaces are the next big thing.
            <br />
            <br />
            With businesses fully or semi-remote and looking to set up their
            micro units across centres, temporary office spaces are the best
            alternatives. Businesses are looking for better options for
            productivity and employee well-being at all costs. And if these
            office spaces are offered with no contracts, lock-ins, and just a
            click away to help you find great workspaces, why not? If you are
            looking to book your office space in Pune for rent, right here!
            <br />
            <br />
          </p>
        </div>
      )
    case "New Delhi":
      return (
        <div className="col-md-12">
          <h3 style={{ fontWeight: "bold" }}>Office Spaces in New Delhi</h3>
          <p>
            New Delhi is a vibrant commercial capital where tradition meets
            innovation. From Connaught Place to Nehru Place, the city is home to
            a thriving ecosystem of professionals, startups, and global
            businesses. The demand for flexible office space in New Delhi
            continues to rise with the increasing popularity of coworking,
            hybrid teams, and remote-first businesses.
          </p>
          <p>
            Whether you&rsquo;re looking for an office space TO LET in a
            heritage building or a modern communal workspace in a business park,
            GoFloaters offers verified office space for rent in New Delhi that
            aligns with your budget, goals, and team size.
          </p>
          <br />
          <h3 style={{ fontWeight: "bold" }}>Top Office Spaces in New Delhi</h3>
          <p>
            <strong>1. WeWork - Connaught Place</strong>
            <br />
            Located in Delhi&rsquo;s iconic business district, this coworking
            space offers top-tier amenities and community access. Starts at
            ₹14,000/month.
          </p>
          <p>
            <strong>2. Awfis - Barakhamba Road</strong>
            <br />
            Modern workspace with ergonomic seating, private cabins, and
            high-speed internet. Starting at ₹9,500/month.
          </p>
          <p>
            <strong>3. Innov8 - Saket</strong>
            <br />
            Trendy collaborative working space with vibrant interiors, event
            zones, and networking lounges. Starts at ₹8,000/month.
          </p>
          <p>
            <strong>4. The Office Pass (TOP) - Nehru Place</strong>
            <br />
            Local community-focused coworking space ideal for consultants and
            SMEs. Prices from ₹6,000/month.
          </p>
          <p>
            <strong>5. Regus - Aerocity</strong>
            <br />
            Premium commercial office rental space with international standards.
            Ideal for enterprises and global teams. Starts at ₹16,000/month.
          </p>
          <p>
            <strong>6. 91springboard - Okhla Phase 2</strong>
            <br />
            Startup-friendly coworking with plug-and-play options, mentorship
            programs, and flexible pricing. From ₹7,000/month.
          </p>
          <p>
            <strong>7. myHQ - Connaught Circus</strong>
            <br />
            Affordable coworking across partner cafes and offices. Great for
            freelancers and solopreneurs. Starts at ₹4,000/month.
          </p>
          <br />
          <h3 style={{ fontWeight: "bold" }}>
            Common Questions on Coworking Spaces in New Delhi
          </h3>
          <p>
            <strong>
              Q1: What&rsquo;s the average cost of a coworking space in New
              Delhi?
            </strong>
          </p>
          <p>
            A1: Pricing typically ranges between ₹4,000 and ₹30,000 per
            seat/month based on location and amenities.
          </p>
          <p>
            <strong>
              Q2: Can I get private office cabins in co working spaces?
            </strong>
            <br />
            A2: Yes. Most coworking spaces in Delhi offer private cabin
            solutions within their communal environments.
          </p>
          <p>
            <strong>
              Q3: Are collaborative working spaces viable for large teams?
            </strong>
            <br />
            A3: Yes. Many providers on GoFloaters cater to large teams with
            scalable managed office setups in key business zones.
          </p>
          <p>
            <strong>
              Q4: What are standard amenities in New Delhi coworking spaces?
            </strong>
            <br />
            A4: Wi-Fi, AC, printing, meeting rooms, power backup, cafeteria,
            event spaces, and access control are commonly available.
          </p>
          <p>
            <strong>Q5: Is GST included in the prices listed?</strong>
            <br />
            A5: GST is usually extra. GoFloaters shows full pricing breakdowns
            for clarity.
          </p>
          <p>
            <strong>
              Q6: Do coworking spaces offer daily or hourly passes?
            </strong>
            <br />
            A6: Yes, many coworking spaces in New Delhi offer flexible plans,
            including hourly and daily passes—ideal for freelancers and remote
            workers.
          </p>
          <p>
            <strong>Q7: Can I host client meetings in coworking spaces?</strong>
            <br />
            A7: Absolutely. Most coworking spaces include access to fully
            equipped meeting rooms and presentation areas.
          </p>
          <p>
            <strong>Q8: Are coworking spaces suitable for hybrid teams?</strong>
            <br />
            A8: Yes. Hybrid teams benefit from shared amenities, rotating desk
            access, and scalable private office setups.
          </p>
          <p>
            <strong>
              Q9: Do coworking spaces offer parking or metro accessibility?
            </strong>
            <br />
            A9: Many spaces in areas like Connaught Place, Nehru Place, and
            Saket are metro-connected and provide parking options for members.
          </p>
          <p>
            <strong>
              Q10: What industries commonly use coworking spaces in Delhi?
            </strong>
            <br />
            A10: Coworking spaces attract professionals from tech, design, law,
            media, consulting, and startups.
          </p>
          <br />
          <h3 style={{ fontWeight: "bold" }}>
            Best Locations for Office Spaces in New Delhi
          </h3>
          <ul>
            <li>
              <p>
                <strong>Office Spaces in Connaught Place</strong> – Central
                Business District with heritage appeal and metro access.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Office Spaces in </strong>Nehru Place
                </strong>
                 – Technology and consulting hub with affordable office rental
                spaces.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Office Spaces in </strong>Saket
                </strong>
                 – Premium south Delhi location ideal for modern teams.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Office Spaces in </strong>Okhla Phase 1 &amp; 2
                </strong>
                 – Industrial-commercial blend for startups and agencies.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Office Spaces in </strong>Green Park &amp; 
                </strong>
                <strong>Office Spaces in </strong>
                <strong>Hauz Khas</strong> – Boutique firms and creative teams
                thrive here.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Office Spaces in </strong>Lajpat Nagar &amp; South
                  Extension
                </strong>
                 – Excellent visibility and market access.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Office Spaces in </strong>Aerocity
                </strong>
                 – Ideal for global offices, MNCs, and high-end setups.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <strong>Office Spaces in </strong>Dwarka &amp; 
                </strong>
                <strong>Office Spaces in </strong>
                <strong>Rohini</strong> – Budget-friendly zones for small
                businesses and training centers.
              </p>
            </li>
          </ul>
          <br />
          <h3 style={{ fontWeight: "bold" }}>
            Top Commercial Parks and Business Hubs in Delhi NCR
          </h3>
          <ul>
            <li>
              <p>Worldmark, Aerocity</p>
            </li>
            <li>
              <p>Nehru Place Business Centre</p>
            </li>
            <li>
              <p>Bhikaji Cama Place</p>
            </li>
            <li>
              <p>Connaught Place Heritage Blocks</p>
            </li>
            <li>
              <p>DLF Capitol Point</p>
            </li>
            <li>
              <p>IFCI Tower, Barakhamba Road</p>
            </li>
            <li>
              <p>Eros Corporate Tower, Nehru Place</p>
            </li>
            <li>
              <p>Statesman House</p>
            </li>
          </ul>
          <br />
          <h3 style={{ fontWeight: "bold" }}>
            Popular Coworking Locations in New Delhi
          </h3>
          <ul>
            <li>
              <p>
                <strong>Coworking Spaces in Connaught Place</strong> – Premium,
                historic, and well-connected.
              </p>
            </li>
            <li>
              <p>
                <strong>Coworking </strong>
                <strong>Spaces </strong>
                <strong>in Nehru Place</strong> – Affordable and centrally
                located.
              </p>
            </li>
            <li>
              <p>
                <strong>Coworking </strong>
                <strong>Spaces </strong>
                <strong>in Saket &amp; Hauz Khas</strong> – Creative, modern,
                and well-networked.
              </p>
            </li>
            <li>
              <p>
                <strong>Coworking </strong>
                <strong>Spaces </strong>
                <strong>in Aerocity</strong> – Corporate-grade workspaces with
                premium amenities.
              </p>
            </li>
            <li>
              <p>
                <strong>Coworking </strong>
                <strong>Spaces </strong>
                <strong>in Okhla &amp; Coworking </strong>
                <strong>Spaces in </strong>
                <strong>Lajpat Nagar</strong> – Industrial meets innovation.
              </p>
            </li>
          </ul>
          <br />
          <h3 style={{ fontWeight: "bold" }}>
            Coworking Space Price in New Delhi
          </h3>
          <p>
            The cost of coworking spaces in New Delhi varies depending on the
            location, facilities, and provider. Spaces in business hubs like
            Connaught Place and Aerocity are more premium, while areas like
            Lajpat Nagar and Okhla offer more budget-friendly options. Prices
            typically range from ₹4,000 to ₹30,000 per seat per month.
          </p>
          <ul>
            <li>
              <p>
                <strong>Cost of Coworking Space in Connaught Place:</strong>
                 ₹12,000 to ₹30,000
              </p>
            </li>
            <li>
              <p>
                <strong>Cost of Coworking Space in Nehru Place:</strong> ₹6,000
                to ₹16,000
              </p>
            </li>
            <li>
              <p>
                <strong>Cost of Coworking Space in Saket:</strong> ₹8,000 to
                ₹18,000
              </p>
            </li>
            <li>
              <p>
                <strong>Cost of Coworking Space in Okhla:</strong> ₹5,000 to
                ₹10,000
              </p>
            </li>
            <li>
              <p>
                <strong>Cost of Coworking Space in Aerocity:</strong> ₹15,000 to
                ₹30,000
              </p>
            </li>
            <li>
              <p>
                <strong>
                  Cost of Coworking Space in Lajpat Nagar &amp; South Extension:
                </strong>
                 ₹5,000 to ₹12,000
              </p>
            </li>
            <li>
              <p>
                <strong>
                  Cost of Coworking Space in Hauz Khas &amp; Green Park:
                </strong>
                 ₹6,000 to ₹14,000
              </p>
            </li>
            <li>
              <p>
                <strong>Cost of Coworking Space in Dwarka &amp; Rohini:</strong>
                 ₹4,000 to ₹10,000
              </p>
            </li>
          </ul>
          <br />
          <h3 style={{ fontWeight: "bold" }}>
            Questions on Coworking in New Delhi
          </h3>
          <p>
            <strong>
              Q. What is the cost of shared office space in New Delhi?
            </strong>
            <br />
            A. It ranges from ₹4,000 to ₹30,000 per seat/month depending on the
            location and amenities.
          </p>
          <p>
            <strong>Q. Where can I find coworking spaces in New Delhi?</strong>
            <br />
            A. You can find coworking spaces in Connaught Place, Nehru Place,
            Saket, Okhla, and Aerocity, among others.
          </p>
          <p>
            <strong>Q. Are there budget coworking options in New Delhi?</strong>
            <br />
            A. Yes, areas like Rohini, Okhla, and Lajpat Nagar offer affordable
            coworking spaces.
          </p>
          <p>
            <strong>
              Q. What are the premium coworking zones in New Delhi?
            </strong>
            <br />
            A. Aerocity, Connaught Place, and Saket are popular for high-end
            coworking options.
          </p>
          <p>
            <strong>
              Q. Which coworking spaces are ideal for freelancers in New Delhi?
            </strong>
            <br />
            A. Spaces like myHQ, Innov8, and The Office Pass offer flexible
            plans suited to freelancers and remote workers.
          </p>
          <p>
            <strong>Q. Can I find shared office space near Delhi Metro?</strong>
            <br />
            A. Most coworking spaces in New Delhi are strategically located near
            metro stations for easy access.
          </p>
          <p>
            <strong>
              Q. Do coworking spaces offer flexible rental durations?
            </strong>
            <br />
            A. Yes, GoFloaters listings include options for hourly, daily,
            weekly, and monthly usage.
          </p>
          <br />
          <h3 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters for Office Spaces in New Delhi?
          </h3>
          <ul>
            <li>
              <p>
                <strong>Transparent Rentals</strong> – Real-time prices, no
                hidden charges.
              </p>
            </li>
            <li>
              <p>
                <strong>Customizable Office Space</strong> – Choose layouts and
                branding your way.
              </p>
            </li>
            <li>
              <p>
                <strong>Flexible Plans</strong> – Hourly, daily, or long-term
                use.
              </p>
            </li>
            <li>
              <p>
                <strong>Prime Listings</strong> – Coverage across Delhi&rsquo;s
                commercial and emerging localities.
              </p>
            </li>
            <li>
              <p>
                <strong>Verified Quality</strong> – Each listing is
                quality-checked and ready-to-move-in.
              </p>
            </li>
          </ul>
          <p>
            From freelancers to MNCs, GoFloaters is your one-stop solution to
            discover the perfect office space for rent in New Delhi—be it a
            quiet desk, buzzing communal workspace, or fully managed office
            setup.
          </p>
        </div>
      )
    case "Noida":
      return (
        <div className="col-md-12">
          <h3>Office Space in Noida</h3>
          <p>
            Looking for shared office space in Noida? Book the best office space
            in Noida for teams of all sizes with all amenities, from hot desks
            to private cabins.
            <br />
            New Okhla Industrial Development Authority, in short, Noida is a
            satellite city of Delhi and a part of the NCR or National Capital
            Region of India. Its administrative headquarters is situated in
            Greater Noida. 50% of Noida is covered by trees and hence it is
            India’s greenest city. The Noida authority has a surplus of funds,
            so much so that it can run the city efficiently even if it does not
            collect any taxes from its taxpayers for 5 years in a row. This
            makes the Noida Authority one of the richest civic bodies in all of
            India. Noida comes under the Special Economic Zone (SEZ).
            <br />
            <br />
            Noida has become a popular spot for Information Technology
            industries as many of the IT companies have set up base here.
            Companies offering services in the fields of banking, pharma,
            financial services, auto, insurance, manufacturing and fast-moving
            goods too call Noida their home. The past decade has seen Noida
            emerge as a hub for mobile and software companies. Companies like
            Samsung, HCL, Barclay’s, CSC and Agicent are major contributors to
            the city’s economy due to their software product development and
            service export dealing in foreign currency.
            <br />
            <br />
            Shared office spaces offer individuals and companies the flexibility
            of access to work spaces that have all the amenities of a
            traditional office and sometimes more on a simple rental model. The
            biggest advantage of shared office spaces is their affordability.
            Office spaces on GoFloaters platform are available on monthly basis
            rentals without long term contracts that block you in.
            <br />
            <br />
            Some popular brands of coworking spaces in Noida are Regus, Awfis,
            ABL Workspaces, Workplace83, Let’s Connect Coworking and
            91Springboard.
            <br />
            <br />
          </p>
        </div>
      )
    case "Gurugram":
      return (
        <div className="col-md-12">
          <h3>Find best shared office space in Gurugram</h3>
          <p>
            Gurugram is one of the five largest cities in the National Capital
            Region. It is situated in Haryana and is well known for its growing
            IT presence and banking hubs.
            <br />
            <br />
            A city that has been planned and built by developers, Gurugram has
            excellent connectivity, both within the town and to other major
            metropolises. The town has built its own metro rail line, with
            connectivity to the Delhi Metro, making New Delhi, Noida and other
            cities easily accessible. The city also has numerous organised
            sectors built across the city with parks and tree-lined roads.
            <br />
            <br />
            <b>A corporate haven</b>
            <br />
            In the last few decades, the city has seen substantial economic
            growth with the influx of IT companies alongside other corporates
            and MNC’s. Economic growth in the region began with establishing the
            Maruti Suzuki manufacturing plant, which General Electric and others
            soon followed.
            <br />
            <br />
            Today, Gurugram boasts a vibrant social scene and is home to nearly
            12 lakh people. A quickly modernising city, it has also begun to
            adopt the remote work lifestyle, with many employees being given the
            opportunity to decide how and where they work.
            <br />
            <br />
            In search of a great place to work in Gurugram? Then let GoFloaters
            be your one-stop-shop! We offer various workspaces to suit your
            every need from all across the city—Book now on the GoFloaters
            website or on the go via the GoFloaters app.
            <br />
            <br />
          </p>
        </div>
      )
    case "Ahmedabad":
      return (
        <div className="col-md-12">
          <h3>Affordable office space in Ahmedabad</h3>
          <p>
            How much are you willing to pay for your private office in
            Ahmedabad? 30K, 50K or 1L a month? With the changing ways of
            working, what is the guarantee that you can get to work tomorrow, or
            your team can get together for that conference?
            <br />
            <br />
            How many of your best talents are willing to commute and experience
            the traditional hustle and bustle of getting to the office?
            <br />
            <br />
            Times have changed. Workforces today enjoy working out of private
            yet open and collaborative environments. Amidst the novel ways of
            working, it is essential to assess and continue the value of work
            culture the teams; companies stand with alternative approaches.
            <br />
            <br />
            On-demand Office Space rental mainly benefits distributed and
            growing teams and businesses looking for some long-term but not a
            full-lease obligation. In an open space, you may bump into your
            competition and may not want to be around them. Have dedicated
            spaces–be it managed boss cabin, private pods or cabins, meeting and
            conference room for presentations and training or team to sit
            together and work with no distraction.
            <br />
            <br />
            Why do you need to rent a monthly or designated space?
            <ul>
              <li>
                Designated spaces are needed for various reasons, most notably
                being associated with a real estate space that solely belongs to
                the team.
              </li>
              <li>
                The nature of the business can make us opt for private spaces.
              </li>
              <li>
                Focused space - The team needs undivided attention and freedom
                from distractions.
              </li>
              <li>
                Budget and comprehensive package deal in the most suitable
                locations that accessible to all team members
              </li>
              <li>Enjoy the benefits of being a part of a large community</li>
            </ul>
            So why GoFloaters?
            <br />
            Choosing GoFloaters to shortlist your office space in Ahmedabad
            makes it easier to find a suitable all-encompassing affordable
            workspace. Why should you spend all day googling through the web and
            endlessly wait to find your best!
            <br />
            <br />
          </p>
        </div>
      )
    case "Coimbatore":
      return (
        <div className="col-md-12">
          <h3>
            Find Private Office Space in Coimbatore with short & long term
            benefits.
          </h3>
          <p>
            With many companies gone remote, many permanently allowing work from
            anywhere or WFH and some exploring 4-day workweek because of
            alternative ways of working, flexible office spaces by month have
            become a great alternative.
            <br />
            <br />
            Businesses and start-ups have given up their permanent commercial
            offices and are an option for flexible office space options
            on-demand or by month that are well built and well-furnished to
            ensure smooth operation.
            <br />
            <br />
            The future is uncertain. And no company wants to make any long-term
            investment. The focus is now on the well-being of the employees and
            productivity.
            <br />
            <br />
            Gone are the days, where companies decided the future of office real
            estate and the long-term commercial agreements. Companies are
            adopting employee-centric practices, and renting temporary office
            spaces by the hour, day, or short term serves the very purpose.
            <br />
            <br />
            If you have just vacated your permanent real estate then, this is
            the place to be in. Discover and choose from the array of shared
            office space that allows low expenditure. Making use of the flexible
            remote workspaces in your neighbourhood or common to the employees
            is the smartest and ideal way of dealing with the need for a closed
            office environment.
            <br />
            <br />
            The best way to find a monthly office space is
            <br />
            1) Figure the number of workforces, suitable infrastructure and
            space size that you required
            <br />
            2) Log on to GoFloaters and choose the location of interest.
            <br />
            3) Click on Enquire Now, and we will get back to you ASAP with the
            details and necessary information to book your space.
            <br />
            <br />
            Long-term members also get the opportunity to access all amenities
            and services of the monthly, fortnightly or even weekly spaces. In
            addition, would be the community partnership and other offer
            benefits at GoFloaters.
          </p>
        </div>
      )
    case "Ghaziabad":
      return (
        <div className="col-md-12">
          <h3>Office Space in Ghaziabad</h3>
          <p>
            A thriving Industrial city, Ghaziabad is a hub for Manufacturing in
            the National Capital Region and is quickly growing to be a go-to
            choice for corporates. Founded in 1740 AD, the city was once the
            picnic spot for the Mughal Royal family. Today, however, it has been
            replaced by a municipality consisting of 100 wards and is one of the
            fastest-growing cities in NCR and the 2nd fastest growing city in
            the world.
            <br />
            <br />
            Home to 22 lakh people, the city, is the 3rd most populated in UP
            and continues to be the go to destination for people looking for
            work or a brighter future. Its growing population is well supported
            by the city's administration which has ensured planned development
            across the region. Ghaziabad has always been known for its great
            connectivity, which first lured industrialists to the area. This
            continues to be the case with well-developed roads and amenities for
            it’s residents.
            <br />
            <br />
            Today, major companies like Honeywell, Maersk, CISCO, and Siemens
            have set up offices in Ghaziabad's tech parks and office complexes,
            and the number continues to rise. Owing to its nascent stage,
            Coworking spaces offer a great opportunity for companies to set up a
            presence in the city without the expenses and commitment of a
            full-scale office.
            <br />
            <br />
            At GoFloaters, we offer various spaces in Ghaziabad from Hot desks,
            Meeting rooms and Offices, all on rent with amenities such as Wifi
            and Pantry included. You can learn more about co-working spaces in
            the city and even book your space right away on our website and
            mobile app.
          </p>
        </div>
      )
    case "Indore":
      return (
        <div className="col-md-12">
          <h3>Lively shared office space in Indore</h3>
          <p>
            Indore is located in the state of Madhya Pradesh. It was founded in
            1715 as a trade market on the Narmada Valley route by a landlord.
            The name of the city is derived from the historic Indreshwar temple.
            <br />
            <br />
            <b>A hub for growth</b>
            <br />
            The city is a well-established metropolis and was recently awarded
            the title of the cleanest city in India for the third consecutive
            time under the Swach Bharat Abhiyan. Notable for its importance in
            trade, finance and distribution, Indore serves as a connecting point
            in the region. This attracts the state’s best talent to the city and
            ensures the consistent inflow of commerce, which has facilitated its
            growth over the years. Today Indore is home to renowned Indian
            colleges such as the Indian Institute of Management (IIM Indore),
            Dr. APJ Abdul Kalam University, Devi Ahilya Vishwavidyalaya and many
            others.
            <br />
            <br />
            Owing to its regional importance, many corporations have set up
            offices in Indore to access the city’s growing talent pool. These
            include leading consultancy firms such as TCS and Accenture, retail
            companies such as Flipkart and tech outfits including Google, just
            to name a few.
            <br />
            <br />
            GoFloaters offers various remote work opportunities in Indore, from
            hot desks, meeting spaces and office spaces. The work from anywhere
            (WFA) movement is here and presents numerous benefits to employers,
            freelancers and entrepreneurs alike. You can explore our range of
            coworking offerings on the GoFloaters website or the mobile app.
            <br />
            <br />
          </p>
        </div>
      )
    case "Kochi":
      return (
        <div className="col-md-12">
          <h3>Find your Office Space for Rental in Kochi</h3>
          <p>
            A 300 sqft in a prime location in Kochi costs you 20K! What if we
            said at GoFloaters we can give you double the size, lesser rental,
            no contract, no lock-in, spaces that saves on commute time,? These
            well managed plug and play office spaces with a dynamic and active
            community are available at a lesser cost? GoFloaters has partnered
            with the best coworking spaces in the city to provide you with great
            deals for monthly space rentals and also helps you with community
            partner benefits worth a 1cr. Office space are usually found in the
            prime CBD of cities, making it awfully expensive and dent the
            monthly budgets of businesses. In the current work environment,
            there is no guarantee that your team can walk into your rented
            office space every day. Employees and freelancers today are
            comfortable with the concept of work from anywhere or remote
            workforces prefer a hybrid work model.
            <br />
            <br />
            Keeping that in mind, workforce needs a space that lets them
            collaborate and enjoy an uninterrupted day’s work. They prefer
            designated workspaces that allow them to maintain office decorum yet
            enjoy a vibrant day at work.
            <br />
            <br />
            Monthly offices have gained prominence because of the specified
            location for the term required, attached with private rooms and
            dedicated desks.
            <br />
            <br />
            Sometimes, the monthly office rentals are preferred because of a
            type of project, confidential business, limited distraction and
            independent team operation. <br />
            <br />
            When you decide to choose your workspace for the term, be sure to
            consider the
            <br />
            Privacy
            <br />
            Lease term
            <br />
            Benefits and resources you need in the spaces for daily run
            <br />
            Number of people
            <br />
            Number and categorization of workspace that you need
            <br />
            Every monthly office space in Kochi comes with well-built
            infrastructure & furniture including hi speed internet, office
            stationery, full access to amenities in the workspaces.
            <br />
            <br />
            Or simply let GoFloaters assist you!
            <br />
            <br />
          </p>
        </div>
      )
    case "Kolkata":
      return (
        <div className="col-md-12">
          <h3>Are you considering renting shared office space in Kolkata?</h3>
          <p>
            Cultural Heritage - Intellectual Hub - Culinary Delights -
            Entrepreneurial Spirit - Rich History. Kolkata, fondly known as the
            &quot;City of Joy,&quot; is a treasure trove of unique experiences
            that have shaped its character over centuries.
            <br />
            <br />
            <strong>Intellectual Oasis</strong>
            <br />
            <br />
            Kolkata's vibrant tapestry comprises scholars, artists, and
            professionals from across India and the world, all drawn to its
            thriving intellectual ecosystem. Over the years, Kolkata has
            witnessed a resurgence of innovative enterprises spanning tech
            startups, creative ventures, and more. This renaissance has prompted
            an evolution in workspace solutions for those looking to establish
            their footprint in the 'Intellectual Hub of India.'
            <br />
            <br />
            The modern answer? Co-working spaces! In recent times, leading
            co-working providers have established their centers in Kolkata,
            including IncuSpace, Innov8, The Hive, WorkWise, and AvantGarde
            Spaces. This diverse range of choices empowers local entrepreneurs
            to tailor their workspace to their exact needs.
            <br />
            <br />
            Co-working venues offer more than just shared desks; they include
            fully equipped meeting rooms and flexible office spaces available
            for monthly rentals.
            <br />
            <br />
            Discover the variety of workspace options available in Kolkata right
            here on <a href="https://gofloaters.com/">GoFloaters</a>. We provide
            office spaces for rent on both monthly and daily arrangements, with
            no long-term commitments or contracts.
            <br />
            <br />
            Take the next step and reserve your workspace today in the 'City of
            Joy'! <br />
            <br />
          </p>
        </div>
      )
    case "Trichy":
      return (
        <div className="col-md-12">
          <h3>Tempted to rent affordable shared office in Trichy?</h3>
          <p>
            Safe and secure long-term office spaces for 1 to 30 member teams
            <br />
            <br />
            Best of everything your team will need is available at workspaces.
            <br />
            <br />
            If you are looking for an inspiring, motivating, and productive
            space for your teams and colleagues, this is for you!
            <br />
            <br />
            GoFloaters offers on-demand workspace discovery and booking
            benefits. The workspaces listed in GoFloaters help you beat the
            work-from-home value and make available a workspace away from home,
            around your neighbourhood.
            <br />
            <br />
            In a smaller city like Trichy, where outlets are limited, the office
            spaces or the monthly spaces offered through GoFloaters add value to
            the mental well-being and physical office rentals. All the monthly
            space takers have access to all amenities in the property, in
            addition to enjoying benefits of being a long-term member of the
            space being used. On-site cafeteria and other social options can be
            conveniently used.
            <br />
            <br />
            The prime focus of the monthly spaces is to provide flexible offices
            combined with privacy and collaboration for individuals and teams.
            The monthly spaces in Trichy at GoFloaters attract remote workers,
            start-ups, and distributed teams to retreat constructive work hours.
            <br />
            <br />
          </p>
        </div>
      )
    case "Chandigarh":
      return (
        <div className="col-md-12">
          <h3>Discover Premium Shared Office Spaces in Chandigarh</h3>
          <p>
            Chandigarh, known for its well-planned architecture and urban
            design, is rapidly emerging as a hub for professionals and startups.
            The city, with its unique blend of modernity and tradition, boasts a
            growing number of coworking spaces, dedicated desks, and monthly
            office rentals. This ensures that there's a perfect space to fit the
            unique requirements of every individual and business.
            <br />
            <br />
            For enterprises, startups, and freelancers alike, GoFloaters is here
            to assist with flexible monthly rental options. Explore the shared
            office spaces in Chandigarh that cater to your professional
            aspirations.
            <br />
            <br />
          </p>
        </div>
      )
    case "Visakhapatnam":
      return (
        <div className="col-md-12">
          <h3>Inviting shared office space in Vishakpatnam</h3>
          <p>
            If traditional office spaces, long-term investment and expenditures
            can be replaced with ready-to-occupy plug and play offices on
            monthly or short-term rentals that are walkable for your teams and
            close to their neighbourhood, making it the perfect workspace.
            <br />
            <br />
            At GoFloaters, you will find office spaces on monthly rental in
            Visakhapatnam.
            <br />
            <br />
            Sometimes, we are all forced to sit at home and work virtually as we
            cannot find workspaces that are affordable and vibrant to achieve
            our goals. How boring is that!
            <br />
            <br />
            With so much uncertainty around us, it is difficult to commit to any
            real estate in the long run, leave alone renting out a large office
            space in the city. With the economy and businesses being in the
            doldrums, it is highly risky to invest in anything so farfetched.
            Monthly rentals in coworking spaces make it easier for teams to rent
            short-term and medium-term spaces. It also helps you have access to
            an entire network of the workforce working out of the coworking
            centre. Many business relationships have been fostered in such
            environments and have grown to become great companies. The right
            environment can create a great impact.
            <br />
            <br />
            Each one of us deserves office space that inspires us and drives the
            energy to be at productive best. With a coworking workspace allowing
            us to occupy and use the amenities, networking with like-minded
            people and fostering an endless business relationship, what else
            could we ask for?
            <br />
            <br />
            Coworking centres in Visakhapatnam have the best work environment
            suitable for freelancers, independent professionals, entrepreneurs,
            or distributed teams.
            <br />
            <br />
            Dedicated Desks, Meeting Rooms, Conference Rooms, Private Cabins
            listed at GoFloaters are amazing!
            <br />
            <br />
          </p>
        </div>
      )
    case "Madurai":
      return (
        <div className="col-md-12">
          <h3>Find best shared Office Space in Madurai</h3>
          <p>
            Long-term commercial agreement is a thing of the past. From
            start-ups to large companies, everyone is uncertain to commit to
            long-term spaces, particularly with the changed dynamics of
            workplaces.
            <br />
            <br />
            Coworking space has turned out to be cost-effective and low risk
            solutions to long-term commitment for office real estate.
            <br />
            <br />
            At GoFloaters, we aim to provide you with alternative office spaces
            than expensive commitments. Our monthly space offerings have helped
            not just individuals but companies and distributed teams to take up
            minimum committed private office desks and spaces.
            <br />
            <br />
            Around Madurai City, would you prefer paying Rs.16000/- for 12
            months for a 1000 square feet unfurnished space exclusive of any
            amenities besides operational expenses or Rs. 5999/- per month per
            person with all work amenities inclusive.
            <br />
            <br />
            All monthly space offered by GoFloaters are flexible on long-term
            and short commitments. The team offices spaces are suitable for
            accommodating professionals from one to 40+. If you are looking for
            an office space to lease in Madurai, it is worth checking out
            GoFloaters list of spaces.
            <br />
            <br />
            From private cabins to meeting rooms to dedicated desks, these safe
            & well-furnished coworking spaces support you in being productive
            and adopt work-life balance.
            <br />
            It is time to do away with extensive agreements, bonded sheets,
            renewing YoY, twelve-monthly negotiations with landlords or house
            owners. It is time to commit to short-term workspaces, flexible and
            collaborative spaces.
            <br />
            <br />
          </p>
        </div>
      )
    default:
      return <div className="col-md-12"></div>
  }
}

export function OfficeContentFaqs(props) {
  // Create a collapsible FAQ section that adds the city name dynamically to the question

  switch (props.city) {
    case "Chennai":
      return (
        <div className="col-md-12">
          <h3 style={{ fontWeight: "bold" }}>
            Common questions on commercial offices Chennai
          </h3>
          <br />
          {/* Create a list of 5 sample questions. Accordion not needed.  */}
          <div className="row">
            <div className="col-md-12">
              <strong>
                1. What is the difference between coworking and managed offices?
              </strong>
              <p>
                Coworking spaces are shared environments where multiple
                businesses work together, offering flexibility and networking
                opportunities. Managed offices, on the other hand, are fully
                serviced, private workspaces tailored to a single company’s
                needs, providing customization, branding, and autonomy.
              </p>
            </div>
            <div className="col-md-12">
              <strong>
                2. How does GoFloaters help in finding office space in Chennai?
              </strong>
              <p>
                GoFloaters assists businesses in locating office spaces by
                offering flexible coworking and meeting rooms across multiple
                cities in India, including Chennai.
              </p>
            </div>
            <div className="col-md-12">
              <strong>
                3. Can I get a private office within a coworking space in
                Chennai?
              </strong>
              <p>
                Yes, GoFloaters' coworking spaces often provide private offices
                within their shared environments in Chennai. These offices offer
                privacy while still allowing access to communal amenities like
                meeting rooms, lounges, and networking opportunities.
              </p>
            </div>
            <div className="col-md-12">
              <strong>
                4. Can I customize my office within a managed office space in
                Chennai?
              </strong>
              <p>
                GoFloaters' managed office spaces can be customized to fit a
                company’s branding, layout, and operational needs. Businesses
                can modify interiors, integrate technology, and personalize
                workspaces to enhance productivity and employee experience.
              </p>
            </div>
            <div className="col-md-12">
              <strong>
                5. For what team size is a managed office ideal in Chennai?
              </strong>
              <p>
                GoFloaters' managed office spaces are ideal for teams ranging
                from small startups to large enterprises. They provide
                scalability, allowing businesses to expand without relocating.
                Typically, companies with 20 to 200+ employees benefit from
                managed office solutions.
              </p>
            </div>
            <div className="col-md-12">
              <strong>
                6. What is the price range of coworking offices in Chennai?
              </strong>
              <p>
                GoFloaters offers coworking offices in Chennai with rent ranging
                from ₹5,000 to ₹25,000 per seat. The rent varies based on
                location, building, and amenities provided.
              </p>
            </div>
          </div>
        </div>
      )
    case "Mumbai":
      return (
        <div className="col-md-12">
          <h3 style={{ fontWeight: "bold" }}>
            Common Questions on Commercial Offices in Mumbai
          </h3>
          <br />
          {/* Create a list of 5 sample questions. Accordion not needed.  */}
          <div className="row">
            <div className="col-md-12">
              <strong>
                1. What is the difference between coworking and managed offices?
              </strong>
              <p>
                Coworking spaces are communal working spaces where businesses
                and individuals share the same environment, promoting
                collaboration, cost-efficiency, and flexibility. Managed offices
                are private, branded office rental spaces that offer autonomy,
                end-to-end service, and complete customization for a single
                company.
              </p>
            </div>
            <div className="col-md-12">
              <strong>
                2. How does GoFloaters help in finding office space in Mumbai?
              </strong>
              <p>
                GoFloaters offers access to a wide range of coworking space
                Mumbai options and managed offices across key business hubs in
                the city. The platform allows you to view amenities, compare
                pricing, and book shared or private spaces in minutes.
              </p>
            </div>
            <div className="col-md-12">
              <strong>
                3. Can I get a private office within a coworking space in
                Mumbai?
              </strong>
              <p>
                Yes. Most coworking spaces in Mumbai provide private office
                cabins within a larger communal workspace setup. These are ideal
                for teams that want privacy while retaining access to shared
                resources.
              </p>
            </div>
            <div className="col-md-12">
              <strong>
                4. Can I customize my office within a managed office space in
                Mumbai?
              </strong>
              <p>
                Absolutely. GoFloaters offers managed offices that can be fully
                customized with your branding, furniture layouts, team sizes,
                and tech integrations.
              </p>
            </div>
            <div className="col-md-12">
              <strong>
                5. For what team size is a managed office ideal in Mumbai?
              </strong>
              <p>
                Managed office spaces are suitable for growing startups, SMEs,
                and large enterprises. GoFloaters listings support teams ranging
                from 10 to 500+ employees.
              </p>
            </div>
            <div className="col-md-12">
              <strong>
                6. What is the price range of coworking offices in Mumbai?
              </strong>
              <p>
                Coworking spaces in Mumbai generally range from ₹5,000 to
                ₹35,000 per seat/month depending on location, amenities, and
                provider.
              </p>
            </div>
          </div>
        </div>
      )
    case "New Delhi":
      return (
        <div className="col-md-12">
          <h3 style={{ fontWeight: "bold" }}>
            Common Questions on Commercial Offices in New Delhi
          </h3>
          <br />
          {/* Create a list of 5 sample questions. Accordion not needed.  */}
          <div className="row">
            <div className="col-md-12">
              <strong>
                1. What is the difference between coworking and managed offices?
              </strong>
              <p>
                Coworking spaces are communal working spaces shared by multiple
                businesses or professionals, offering cost-efficiency,
                flexibility, and collaborative opportunities. Managed offices
                are fully serviced private office spaces, tailored to a
                company’s needs and offering branding, autonomy, and dedicated
                infrastructure.
              </p>
            </div>
            <div className="col-md-12">
              <strong>
                2. How does GoFloaters help in finding office space in New
                Delhi?
              </strong>
              <p>
                GoFloaters offers a seamless platform to discover coworking
                space New Delhi options, private office cabins, and on-demand
                meeting rooms. You can browse verified listings, compare
                amenities, view transparent pricing, and book instantly across
                top locations in Delhi.
              </p>
            </div>
            <div className="col-md-12">
              <strong>
                3. Can I get a private office within a coworking space in New
                Delhi?
              </strong>
              <p>
                Yes, most New Delhi co working space listings on GoFloaters
                include options for private cabins, ideal for startups, small
                teams, or founders seeking privacy along with shared facilities.
              </p>
            </div>
            <div className="col-md-12">
              <strong>
                4. Can I customize my office within a managed office space in
                New Delhi?
              </strong>
              <p>
                Definitely. GoFloaters’ managed office spaces in New Delhi offer
                the flexibility to tailor interiors, workstations, and branding
                elements to suit your operational needs and company culture.
              </p>
            </div>
            <div className="col-md-12">
              <strong>
                5. For what team size is a managed office ideal in New Delhi?
              </strong>
              <p>
                Managed offices are perfect for teams from 10 to 200+. Whether
                you’re scaling or consolidating, GoFloaters offers scalable
                collaborative working spaces to match your growth.
              </p>
            </div>
            <div className="col-md-12">
              <strong>
                6. What is the price range of coworking offices in New Delhi?
              </strong>
              <p>
                Coworking spaces in Delhi range from ₹4,000 to ₹30,000 per
                seat/month depending on location, workspace format, and service
                levels.
              </p>
            </div>
          </div>
        </div>
      )
    case "Bengaluru":
      return (
        <div className="col-md-12">
          <h3 style={{ fontWeight: "bold" }}>
            Common Questions on Commercial Offices in Bengaluru
          </h3>
          <br />
          {/* Create a list of 5 sample questions. Accordion not needed.  */}
          <div className="row">
            <div className="col-md-12">
              <strong>
                1. What is the difference between coworking and managed offices?
              </strong>
              <p>
                Coworking spaces are communal working spaces where multiple
                businesses share the same infrastructure and amenities, enabling
                flexibility, collaboration, and networking. Managed offices are
                private, fully serviced office spaces customized for a single
                company’s needs, offering autonomy, branding, and tailored
                layouts.
              </p>
            </div>
            <div className="col-md-12">
              <strong>
                2. How does GoFloaters help in finding office space in
                Bengaluru?
              </strong>
              <p>
                GoFloaters helps businesses discover flexible coworking space
                Bengaluru options, private cabins, and meeting rooms across all
                major areas of the city. The platform offers verified listings,
                transparent pricing, and easy booking.
              </p>
            </div>
            <div className="col-md-12">
              <strong>
                3. Can I get a private office within a coworking space in
                Bengaluru?
              </strong>
              <p>
                Yes. Most Bengaluru co working spaces listed on GoFloaters offer
                private offices along with access to shared amenities like
                breakout zones, high-speed internet, and meeting rooms.
              </p>
            </div>
            <div className="col-md-12">
              <strong>
                4. Can I customize my office within a managed office space in
                Bengaluru?
              </strong>
              <p>
                Absolutely. Managed offices in Bengaluru can be branded and
                customized to meet the operational and aesthetic needs of your
                team. From furniture to layout, GoFloaters-managed spaces offer
                flexibility.
              </p>
            </div>
            <div className="col-md-12">
              <strong>
                5. For what team size is a managed office ideal in Bengaluru?
              </strong>
              <p>
                Managed office spaces are suitable for startups, growing teams,
                and large enterprises. GoFloaters serves teams as small as 5 to
                as large as 200+, with scalability features for easy expansion.
              </p>
            </div>
            <div className="col-md-12">
              <strong>
                6. What is the price range of coworking offices in Bengaluru?
              </strong>
              <p>
                Coworking spaces in Bengaluru typically range from ₹4,000 to
                ₹30,000 per seat/month depending on the location, brand, and
                amenities offered.
              </p>
            </div>
          </div>
        </div>
      )
    default:
      return (
        <div className="col-md-12">
          <h3>Frequently Asked Questions</h3>
          <br />
          {/* Create a list of 5 sample questions. Accordion not needed.  */}
          <div className="row">
            <div className="col-md-12">
              <strong>
                1. What is the difference between coworking and managed offices?
              </strong>
              <p>
                Coworking spaces are shared environments where multiple
                businesses work together, offering flexibility and networking
                opportunities. Managed offices, on the other hand, are fully
                serviced, private workspaces tailored to a single company’s
                needs, providing customization, branding, and autonomy.
              </p>
            </div>
            <div className="col-md-12">
              <strong>
                2. How does GoFloaters help in finding office space in{" "}
                {props.city}?
              </strong>
              <p>
                GoFloaters helps businesses find office spaces by offering
                flexible coworking and meeting rooms across multiple cities in
                India including {props.city}.
              </p>
            </div>
            <div className="col-md-12">
              <strong>
                3. Can I get private office within a coworking space in{" "}
                {props.city}?
              </strong>
              <p>
                Yes, GoFloaters coworking spaces often provide private offices
                within their shared environment in {props.city}. These offices
                offer privacy while still allowing access to communal amenities
                like meeting rooms, lounges, and networking opportunities.
              </p>
            </div>
            <div className="col-md-12">
              <strong>
                4. Can I customize my office within a managed office space in{" "}
                {props.city}?
              </strong>
              <p>
                GoFloaters managed office spaces can be customized to fit a
                company’s branding, layout, and operational needs. Businesses
                can modify interiors, integrate technology, and personalize
                workspaces to enhance productivity and employee experience.
              </p>
            </div>
            <div className="col-md-12">
              <strong>
                5. For what team size is managed office ideal in {props.city}?
              </strong>
              <p>
                GoFloaters managed office spaces are ideal for teams ranging
                from small startups to large enterprises. They provide
                scalability, allowing businesses to expand without relocating.
                Typically, companies with 20 to 200+ employees benefit from
                managed office solutions.
              </p>
            </div>
            <div className="col-md-12">
              <strong>
                6. What is the price range of coworking offices in {props.city}?
              </strong>
              <p>
                GoFloaters offers coworking offices in the rent range of Rs 5000
                to Rs 25000 per seat in {props.city}. The rent varies based on
                location, building and amenities provided.
              </p>
            </div>
          </div>
        </div>
      )
  }
}

export function OfficeContentBottom(props) {
  switch (props.city) {
    case "Bengaluru":
      return (
        <div className="col-md-12">
          <h4 style={{ fontWeight: "bold" }}>
            Top Office Space Locations in Bangalore
          </h4>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Koramangala</h5>
          <p>
            Koramangala is the hub of Indian startup ecosystem. Flipkart and
            Swiggy were two startups that have had humble beginnings here. Not
            only this, Toshiba, Ola, Accel Partners, Instamojo, Robert Bosch,
            Meesho, Mcafee, HackerEarth, Terra Logic among others are based
            here.
            <br />
            <br />
            Located in South-East Bangalore, it is a well-to-do neighbourhood
            with all residential and commercial facilities, exceptional
            infrastructure, social life, and proximity to office locations via
            the roadways, the Kempegowda International Airport for airways
            service and Trinity station for metro rail facilities.&nbsp;
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>HSR Layout</h5>
          <p>
            Hosur-Sarjapur Road or HSR Layout is an affluent neighbourhood
            located in South-East Bangalore. Developed in the 1980s now it has
            emerged into a leading residential area due to its proximity to IT
            Parks in Bangalore. It is also a gateway to Electronic City, a major
            IT hub of the city. HSR Layout is growing rapidly as a startup hub
            of Bangalore as it houses many startups Like Zomato, Udaan, CureFit,
            Gameskraft, OYE Fintech, ThoughtSpot, Trebound Etc. It has many
            co-working spaces like BHIVE Workspace, IndiQube, The Venture
            Studios where many startups work out of.&nbsp;&nbsp;
          </p>
          <br /> <h5 style={{ fontWeight: "bold" }}>Indiranagar</h5>
          <p>
            Indiranagar was developed in the early 1980s, and named after the
            former Prime Minister of India Smt. Indira Gandhi. Initially, the
            neighbourhood was a sight of picturesque houses, mostly owned by the
            government staff. But currently, it has been the focal point of
            Bangalore's phenomenal growth that has turned the city into a
            technology, retail, e-commerce, hospitality paradise.
            <br />
            <br />
            Top companies in and around the area are Dunzo, Boeing, IBM, Karbonn
            Mobiles, Oyo, HSBC, Oracle, Ogilvy, PwC, Cognizant, Dell, LinkedIn
            and many more. With the provision of all modern facilities and
            proximity to other prime business locations via the roadways, metro,
            and the airways, Indiranagar is a favourite destination for the
            businesses who are looking for coworking space in Bangalore.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Whitefield</h5>
          <p>
            Established in the late 1800s as a settlement for the Eurasians and
            Anglo Indians of Bangalore, Whitefield remained a quaint little
            settlement at the eastern periphery of Bangalore city till the late
            1990s when the local IT boom turned it into a major suburb.
            Whitefield in Bangalore, Karnataka was named after D.S. White, the
            founder of the European and Anglo Indian Association
            <br />
            <br />
            With the development of budget-friendly residential localities, the
            corporate hub got a major boost too. It is home to maximum
            technology parks, having thousands of companies such as Accenture,
            Hewlett Packard, AIG, Tesco, TCS, Oracle, Wipro, Unilever, Flipkart,
            SAP, Huawei, Capgemini, IBM, Dell, L&amp;T Infotech among
            others.&nbsp;
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>J.P. Nagar</h5>
          <p>
            Jayaprakash Narayan Nagara, popularly known as J. P. Nagar, is an
            established posh upmarket residential area located in the south of
            Bangalore. Initially, it was recognised as a major housing colony
            but gradually changed into a profitable opportunity for commercial
            projects during the IT boom in the late 1990s.
          </p>
          <br />
          <br />
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters to book your office space in Bangalore
          </h4>
          <p>
            GoFloaters has been in the space of helping individuals and teams
            find flexible and affordable workspaces for over 3 years now.
            GoFloaters was started with a vision to help anyone get an office
            space when they want, where they want and within their budget. We
            set out to build office spaces for a distributed world where
            individuals and teams should be able to work near home.&nbsp;
          </p>
          <br />
          <p>
            Following are the advantages of booking coworking spaces and meeting
            spaces on the GoFloaters app:
          </p>
          <ul>
            <li>
              <strong>Work Near Home:</strong> In most of the cities that we
              serve you can get a space within 5 kms of your home or wherever
              you are
            </li>
            <li>
              <strong>Pay-per-use:</strong> You can book coworking spaces on a
              daily basis and meeting spaces on an hourly basis and pay only for
              the time you have used it.
            </li>
            <li>
              <strong>No contracts:</strong> You don&rsquo;t have to sign any
              kind of contracts with us.&nbsp;
            </li>
            <li>
              <strong>Cost effective:</strong> We have negotiated heavily with
              our space partners to bring you savings of at least 20% if not
              more on the day pass rates and the meeting room rents.
            </li>
            <li>
              <strong>Instant Bookings:</strong> No need to call anyone or email
              anyone to check space availability. You can book coworking spaces
              instantaneously. Meeting spaces just need 30 mins of time for
              confirmation.&nbsp;&nbsp;
            </li>
            <li>
              <strong>Community Perks:</strong> GoFloaters has partnered with
              over 65+ companies to bring you over Rs 1 Crore of benefits to
              you.
            </li>
          </ul>
        </div>
      )
    case "Chennai":
      return (
        <div className="col-md-12">
          <h4 style={{ fontWeight: "bold" }}>
            Top Office Space Locations in Chennai
          </h4>{" "}
          <p>
            <strong>1. Awfis Spero Primus - Guindy</strong>
            <br />A vibrant coworking space in the prime business hub of Guindy,
            offering fully equipped offices at ₹9,000/month. With easy metro
            access, collaborative zones, and dedicated workspaces, it caters to
            professionals seeking convenience and flexibility.
          </p>
          <p>
            <strong>2. WeWork Olympia Cyberspace - Guindy</strong>
            <br />
            Situated in the renowned tech park community, WeWork Olympia
            Cyberspace offers premium office solutions starting at
            ₹18,000/month. With top-tier facilities like desks, meeting rooms,
            and private cabins, it’s tailored for businesses seeking a
            professional environment.
          </p>
          <p>
            <strong>3. Awfis Prestige Palladium Bayan - Nungambakkam</strong>
            <br />
            Offering a range of workspace options, including shared desks and
            dedicated cabins, this space starts at ₹8,999/month. Located in a
            central area with access to major transport links, Awfis provides a
            vibrant and collaborative atmosphere for teams of all sizes.
          </p>
          <p>
            <strong>4. Smartworks Arihant Verge - Perungudi</strong>
            <br />
            Perfect for mid-size to large teams, this managed office space
            provides ergonomic furniture, high-speed internet, and breakout
            areas starting at ₹10,499/month. Its location in the fast-growing
            business hub of Perungudi makes it a strategic choice for expanding
            businesses.
          </p>
          <p>
            <strong>5. Innov8 SKCL Techsquare - Guindy</strong>
            <br />
            Situated in Chennai’s rapidly developing IT hub, this coworking
            space provides cost-effective office solutions at ₹10,499/month.
            It’s equipped with high-speed internet, meeting rooms, and
            collaborative zones for teams looking for a modern work environment.
          </p>
          <p>
            <strong>6. Indiqube Brigade Vantage - Perungudi</strong>
            <br />
            Known for its prime location, Indiqube offers premium private cabins
            and shared workspaces starting at ₹7,500/month. With personalized
            services and networking opportunities, it’s ideal for professionals
            and SMEs.
          </p>
          <p>
            <strong>7. The Executive Zone - Anna Salai</strong>
            <br />A luxurious coworking space offering exclusive office setups
            at ₹9,000/month. Located in one of Chennai’s most prestigious areas,
            it features state-of-the-art meeting rooms, concierge services, and
            24/7 access.
          </p>
          <br />
          <br />
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters to book your office space in Chennai
          </h4>
          <p>
            GoFloaters has been in the space of helping individuals and teams
            find flexible and affordable workspaces for over 3 years now.
            GoFloaters was started with a vision to help anyone get an office
            space when they want, where they want and within their budget. We
            set out to build office spaces for a distributed world where
            individuals and teams should be able to work near home.&nbsp;
          </p>
          <br />
          <p>
            Following are the advantages of booking coworking spaces and meeting
            spaces on the GoFloaters app:
          </p>
          <ul>
            <li>
              <p>
                <strong>Work Near Home :</strong> In most of the cities that we
                serve you can get a space within 5 kms of your home or wherever
                you are
              </p>
            </li>
            <li>
              <p>
                <strong>Pay-per-use : </strong>You can book coworking spaces on
                a daily basis and meeting spaces on an hourly basis and pay only
                for the time you have used it.
              </p>
            </li>
            <li>
              <p>
                <strong>No contracts :</strong> You don&rsquo;t have to sign any
                kind of contracts with us.&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Cost effective :</strong> We have negotiated heavily
                with our space partners to bring you savings of at least 20% if
                not more on the day pass rates and the meeting room rents.
              </p>
            </li>
            <li>
              <p>
                <strong>Instant Bookings : </strong>No need to call anyone or
                email anyone to check space availability. You can book coworking
                spaces instantaneously. Meeting spaces just need 30 mins of time
                for confirmation.&nbsp;&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Community Perks :</strong> GoFloaters has partnered with
                over 65+ companies to bring you over Rs 1 Crore of benefits to
                you.
              </p>
            </li>
          </ul>
        </div>
      )
    case "Hyderabad":
      return (
        <div className="col-md-12">
          <h4 style={{ fontWeight: "bold" }}>
            Top Office Space Locations in Hyderabad
          </h4>
          <br />
          <h5 style={{ fontWeight: "bold" }}>HITEC City</h5>
          <p>
            HITEC CITY, the acronym for Hyderabad Information Technology and
            Engineering Consulting City, is a hub of Information Technology,
            Financial Business, Medical, Engineering and Bioinformatics.
            Popularly acclaimed at &lsquo;Cyberabad&rsquo;, this city spans over
            200 acres of land. Being the center of all IT action, it is also the
            base for some of the most popular coworking spaces and office spaces
            for rent.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Madhapur</h5>
          <p>
            What belonged to an era of suburbs, rocky villages and small towns
            in the 1990s, is the current nucleus of all things IT. Madhapur,
            today boasts of the best coworking spaces in and across Hyderabad
            and also houses the now famous HITEC City. The destination is
            rapidly becoming ideal for business meetings.
          </p>
          <br /> <h5 style={{ fontWeight: "bold" }}>Jubilee Hills</h5>
          <p>
            Jubilee Hills is a luxurious neighbourhood spread across the west of
            Hyderabad. It is one of the high-priced residential, recreational,
            political and commercial localities of the city with land prices
            crossing the sky. This suburb is sandwiched between the wealthy
            commercial district of Banjara Hills and is located within two
            kilometres of Hyderabad's IT hub of HITEC City.
            <br />
            <br />
            Globally known companies like PricewaterhouseCoopers (PWC), ICICI
            and HDFC banks, Seaways, Gateway Media, Lanco Global Systems and
            many more have their headquarters here.&nbsp;
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Begumpet</h5>
          <p>
            Begumpet (&quot;Begum's Place&quot;) is a part of Secunderabad,
            Hyderabad. Begumpet is named after the daughter of the sixth Nizam
            (Mahbub Ali Khan, Asaf Jah VI), Basheer Unnisa Begum. The
            neighbourhood is one of the crucial commercial and residential hubs
            sandwiched between Secunderabad and Hyderabad.
            <br />
            <br />A lucrative business destination for Information Technology
            (IT) companies, it is witnessing a spur in coworking spaces with all
            basic facilities. Begumpet Railway Station provides rail
            connectivity to the area. Other MMTS stations in the vicinity
            include Sanjeevaiah Park and James Street. State-owned TSRTC runs
            the city bus service, connecting Begumpet to major parts of the
            city.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Banjara Hills</h5>
          <p>
            Banjara Hills is an urban commercial centre and one of the most
            affluent neighbourhoods in Hyderabad, Telangana, India. This is an
            upmarket locality close to Jubilee Hills. This area was a hilly
            forest and was least inhabited in the past. It is considered as the
            most expensive zip code in India.
            <br />
            <br />
            This neighbourhood has now been completely transformed and comprises
            prestigious malls like GVK One, City Centre, Midtown, hotels such as
            Taj Mahal, Park Hyatt, ITC, Treebo, The Westin, restaurants like
            Barbeque Nation, Hard Rock Cafe, Bikanervala, Olive Bistro, and
            world-renowned multinational companies like Genpact, Infosys,
            Microsoft India, Hitachi Consulting and many more.
          </p>
          <br />
          <br />
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters to book your office space in Hyderabad
          </h4>
          <p>
            GoFloaters has been in the space of helping individuals and teams
            find flexible and affordable workspaces for over 3 years now.
            GoFloaters was started with a vision to help anyone get an office
            space when they want, where they want and within their budget. We
            set out to build office spaces for a distributed world where
            individuals and teams should be able to work near home.
          </p>
          <br />
          <p>
            Following are the advantages of booking coworking spaces and meeting
            spaces on the GoFloaters app:
          </p>
          <ul>
            <li>
              <p>
                <strong>Work Near Home :</strong> In most of the cities that we
                serve you can get a space within 5 kms of your home or wherever
                you are
              </p>
            </li>
            <li>
              <p>
                <strong>Pay-per-use : </strong>You can book coworking spaces on
                a daily basis and meeting spaces on an hourly basis and pay only
                for the time you have used it.
              </p>
            </li>
            <li>
              <p>
                <strong>No contracts :</strong> You don&rsquo;t have to sign any
                kind of contracts with us.&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Cost effective :</strong> We have negotiated heavily
                with our space partners to bring you savings of at least 20% if
                not more on the day pass rates and the meeting room rents.
              </p>
            </li>
            <li>
              <p>
                <strong>Instant Bookings : </strong>No need to call anyone or
                email anyone to check space availability. You can book coworking
                spaces instantaneously. Meeting spaces just need 30 mins of time
                for confirmation.&nbsp;&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Community Perks :</strong> GoFloaters has partnered with
                over 65+ companies to bring you over Rs 1 Crore of benefits to
                you.
              </p>
            </li>
          </ul>
        </div>
      )
    case "Mumbai":
      return (
        <div className="col-md-12">
          <h4 style={{ fontWeight: "bold" }}>
            Top Office Space Locations in Mumbai
          </h4>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Navi Mumbai</h5>
          <p>
            Navi Mumbai is one of the prime locations for coworking spaces in
            Mumbai. The city is divided into two parts, North Navi Mumbai and
            South Navi Mumbai. It houses a wide range of major educational
            institutions, MNCs like Reliance, Accenture, Siemens, L&amp;T,
            recreational facilities Central Park, Golf Course, Wonder Park etc.
            This destination is the new preference for shared office spaces in
            Mumbai. The basic amenities include parking, spacious floors,
            electricity back up, proximity to the railway station and airport
            among others.&nbsp;
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Andheri and neighbouring areas</h5>
          <p>
            Andheri is the heart of Mumbai. A luxurious locality with renowned
            national and international offices, along with prime residential
            societies. It is one of the growing coworking space destinations in
            Mumbai for many commercial, financial and media houses. The key
            reasons for the area&rsquo;s growth are its proximity to the airport
            and availability of all amenities including an efficient
            transportation system.&nbsp;
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Nariman Point</h5>
          <p>
            Nariman point is known as the home to all the famous banks,
            financial institutions, and many top business houses. From huge car
            parking space to well-maintained buildings, Nariman Point is one of
            the renowned commercial hubs in India.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Thane</h5>
          <p>
            New buildings, presence of all the important amenities and the house
            for all types of office spaces for IT &amp; ITES companies. One of
            the attractive specialties of the place is availability of
            inexpensive office spaces. Not only this, you can get larger floor
            areas for less cost when compared to other areas.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Worli</h5>
          <p>
            Worli is one of Mumbai's affluent areas in South Mumbai, offering a
            charm of both the new and old. The place attracts a lot of
            commercial development annually by big players ensuring 24-hour
            power backup, spacious office spaces, air conditioning, car parking
            and other basic facilities. With this, proximity to the nearest
            railway station and airport makes this destination the most ideal
            out of all.
          </p>
          <br /> <br />
          <br />
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters to book your office space in Mumbai
          </h4>
          <p>
            GoFloaters has been in the space of helping individuals and teams
            find flexible and affordable workspaces for over 3 years now.
            GoFloaters was started with a vision to help anyone get an office
            space when they want, where they want and within their budget. We
            set out to build office spaces for a distributed world where
            individuals and teams should be able to work near home.
          </p>
          <br />
          <p>
            Following are the advantages of booking coworking spaces and meeting
            spaces on the GoFloaters app:
          </p>
          <ul>
            <li>
              <p>
                <strong>Work Near Home :</strong> In most of the cities that we
                serve you can get a space within 5 kms of your home or wherever
                you are
              </p>
            </li>
            <li>
              <p>
                <strong>Pay-per-use : </strong>You can book coworking spaces on
                a daily basis and meeting spaces on an hourly basis and pay only
                for the time you have used it.
              </p>
            </li>
            <li>
              <p>
                <strong>No contracts :</strong> You don&rsquo;t have to sign any
                kind of contracts with us.&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Cost effective :</strong> We have negotiated heavily
                with our space partners to bring you savings of at least 20% if
                not more on the day pass rates and the meeting room rents.
              </p>
            </li>
            <li>
              <p>
                <strong>Instant Bookings : </strong>No need to call anyone or
                email anyone to check space availability. You can book coworking
                spaces instantaneously. Meeting spaces just need 30 mins of time
                for confirmation.&nbsp;&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Community Perks :</strong> GoFloaters has partnered with
                over 65+ companies to bring you over Rs 1 Crore of benefits to
                you.
              </p>
            </li>
          </ul>
        </div>
      )
    case "Pune":
      return (
        <div className="col-md-12">
          <h4 style={{ fontWeight: "bold" }}>
            Top Coworking Locations in Pune
          </h4>
          <br /> <h5 style={{ fontWeight: "bold" }}>Yerawada</h5>
          <p>
            Also known as Yeraoda, Yerwada is home to famous places like Tech
            Park One, Commerce zone, Business bay, and Muttha Towers. These
            names are enough to define the infrastructural and commercial power
            of this area.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Baner</h5>
          <p>
            Baner is widely known for its traditional rituals and bhakti
            aradhana. However, the place is well known for commercial setups
            too. Prabhavee Tech Park and Nanospace IT Park are the two famous
            and must-go places in Baner.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Kharadi</h5>
          <p>
            Located at the banks of Mula-mutha river, Kharadi is a suburb in
            Pune, known for IT companies. EON IT park and world trade center are
            the two attractions of the place.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Hinjawadi</h5>
          <p>
            Pune&rsquo;s Hinjewadi area has travelled far from rural to urban at
            the speed of IT. Once an anonymous destination comprising small
            villages, Hinjewadi is now a crucial spot of real estate. With the
            inauguration of the 2800 acre Rajiv Gandhi Infotech Park and
            subsequent entry of IT companies, this area has witnessed a huge
            growth in its working population.&nbsp;
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Magarpatta</h5>
          <p>
            Magarpatta is a 450 acre, privately owned community, located in the
            Hadapsar area of Pune. It is a rapidly growing commercial hub with
            companies like Deutsche Bank, WNS Global Services, Accenture, HCL
            Technologies among other commercial setups.
          </p>
          <br />
          <br />
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters to book your office space in Pune
          </h4>
          <p>
            GoFloaters has been in the space of helping individuals and teams
            find flexible and affordable workspaces for over 3 years now.
            GoFloaters was started with a vision to help anyone get an office
            space when they want, where they want and within their budget. We
            set out to build office spaces for a distributed world where
            individuals and teams should be able to work near home.
          </p>
          <br />
          <p>
            Following are the advantages of booking coworking spaces and meeting
            spaces on the GoFloaters app:
          </p>
          <ul>
            <li>
              <p>
                <strong>Work Near Home :</strong> In most of the cities that we
                serve you can get a space within 5 kms of your home or wherever
                you are
              </p>
            </li>
            <li>
              <p>
                <strong>Pay-per-use : </strong>You can book coworking spaces on
                a daily basis and meeting spaces on an hourly basis and pay only
                for the time you have used it.
              </p>
            </li>
            <li>
              <p>
                <strong>No contracts :</strong> You don&rsquo;t have to sign any
                kind of contracts with us.&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Cost effective :</strong> We have negotiated heavily
                with our space partners to bring you savings of at least 20% if
                not more on the day pass rates and the meeting room rents.
              </p>
            </li>
            <li>
              <p>
                <strong>Instant Bookings : </strong>No need to call anyone or
                email anyone to check space availability. You can book coworking
                spaces instantaneously. Meeting spaces just need 30 mins of time
                for confirmation.&nbsp;&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Community Perks :</strong> GoFloaters has partnered with
                over 65+ companies to bring you over Rs 1 Crore of benefits to
                you.
              </p>
            </li>
          </ul>
        </div>
      )
    case "New Delhi":
      return (
        <div className="col-md-12">
          <h4 style={{ fontWeight: "bold" }}>Top Office Locations in Delhi</h4>
          <br /> <h5 style={{ fontWeight: "bold" }}>Connaught Place</h5>
          <p>
            A shoppers paradise and a well-known financial, commercial and
            business hub in central Delhi, Connaught Place offers a lot more
            than this. From historic monuments like Jantar Mantar and Agrasen ki
            Baoli, well-known shopping streets like Janpath, religious places
            like Hanuman Mandir and Gurudwara Bangla Sahib, iconic restaurants
            like Sarvana Bavan and Indian Coffee House, headquarters of
            prominent Indian firms like Hindustan Times and British Broadcasting
            Corporation (BBC), the place is a fusion of both the ancient and
            modern.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Rajouri Garden</h5>
          <p>
            Rajouri Garden is a popular residential and market place in West
            Delhi and is marked by its distinct Delhi architecture. It is a home
            of budget-friendly work stations for creative freelancers, newly
            established startups, small and medium enterprises, corporates
            etc.&nbsp;
          </p>
          <br /> <h5 style={{ fontWeight: "bold" }}>Nehru Place</h5>
          <p>
            Nehru Place derives its name from the first Prime Minister of India,
            Pandit Jawaharlal Nehru. The neighbourhood is an epicentre of all
            Information Technology hardware, such as computers, networking
            resources, software, documentation facilities and allied services
            and hence, it is a computer fanatic&rsquo;s shopping paradise. Along
            with this, it is a favourite destination for Generation Y as it
            houses well-known hotels, restaurants and multiplexes in its
            vicinity.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Hauz Khas</h5>
          <p>
            Hauz Khas is one of the favourite destinations of millennials,
            giving a feel of both the urban and rural. Well known in medieval
            times, the Hauz Khas village has amazing buildings built around the
            reservoir. There&rsquo;s a lot one can do in this developing
            neighbourhood. Not only this, but a lot of startups and SMEs are
            also opening their offices here due to the growing innovative
            culture.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Greater Kailash</h5>
          <p>
            Located along the Outer Ring Road, Greater Kailash is one of the
            well-to-do neighbourhoods in South Delhi. Greater Kailash is a
            residential area in South Delhi comprising several neighborhoods and
            multiple markets. It is a synthesis of posh houses and bungalows,
            affluent N and M block markets, cafes, restaurants and branded
            retail stores. Along with these, it is gradually transforming into a
            major workplace hub for budding entrepreneurs, creative freelancers
            and newly born startups.
          </p>
          <br />
          <br />
          <h4 style={{ fontWeight: "bold" }}>
            Find Flexible Office Space for Rent in New Delhi with GoFloaters
          </h4>
          <p>
            Are you looking for affordable office space in New Delhi on a
            monthly rental basis? GoFloaters makes it easy to find and book
            flexible workspaces in Delhi NCR.
            <br />
            <br />
            With GoFloaters, you can find plug-and-play shared office spaces for
            monthly rent in New Delhi close to your home or workplace. Our
            platform offers:
            <br />
            <ul>
              <li>
                Wide Options - Choose from co-working spaces, private offices,
                meeting rooms and virtual offices in Delhi on monthly rentals
              </li>
              <li>
                Cost Savings - Enjoy at least 20% lower rates than market prices
                through our partnerships
              </li>
              <li>
                Flexible Tenure - Rent office space in Delhi for as low as 1
                month without any lock-in
              </li>
              <li>
                Pay-per-use - Only pay for the days you use the office space
                without deposits
              </li>
              <li>
                Easy Bookings - Instantly book co-working spots and meeting
                rooms from our app
              </li>
            </ul>
            So if you are looking to rent office space in Delhi, Gurgaon or
            Noida on a monthly basis, GoFloaters offers you flexible workspaces
            matching your budget and needs. Desks, private cabins, meeting rooms
            or virtual offices - make your pick without contracts!
            <br />
            <br />
          </p>
          <br />
          <p>
            Following are the advantages of booking coworking spaces and meeting
            spaces on the GoFloaters app:
          </p>
          <ul>
            <li>
              <p>
                <strong>Work Near Home :</strong> In most of the cities that we
                serve you can get a space within 5 kms of your home or wherever
                you are
              </p>
            </li>
            <li>
              <p>
                <strong>Pay-per-use : </strong>You can book coworking spaces on
                a daily basis and meeting spaces on an hourly basis and pay only
                for the time you have used it.
              </p>
            </li>
            <li>
              <p>
                <strong>No contracts :</strong> You don&rsquo;t have to sign any
                kind of contracts with us.&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Cost effective :</strong> We have negotiated heavily
                with our space partners to bring you savings of at least 20% if
                not more on the day pass rates and the meeting room rents.
              </p>
            </li>
            <li>
              <p>
                <strong>Instant Bookings : </strong>No need to call anyone or
                email anyone to check space availability. You can book coworking
                spaces instantaneously. Meeting spaces just need 30 mins of time
                for confirmation.&nbsp;&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Community Perks :</strong> GoFloaters has partnered with
                over 65+ companies to bring you over Rs 1 Crore of benefits to
                you.
              </p>
            </li>
          </ul>
        </div>
      )
    case "Noida":
      return (
        <div className="col-md-12">
          <h4 style={{ fontWeight: "bold" }}>
            Top Office Space Locations in Noida
          </h4>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Noida City Centre</h5>
          <p>
            Construction is currently underway for this project. The proposed
            plot of land that is to be developed is around 99 hectares in area.
            The city centre will bring together shopping arcades, opulent office
            spaces and international retail food chains along with multiplexes
            and 5-star hotels.
          </p>
          <br /> <h5 style={{ fontWeight: "bold" }}>Sector 18</h5>
          <p>
            The commercial complex in this centre has turned out to be a centre
            point for trade and commercial activities. This is an ideal location
            for traders as Sector 18 provides office facilities and
            opportunities for commercial expansion. The malls here offer a gamut
            of international and national clothing brands and restaurant chains
            that suit all pockets. It also has 5-star hotels and multiplexes.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Sector 62</h5>
          <p>
            It is a noteworthy location in central Noida. The commercial and
            residential areas are clearly demarcated here. The Noida campuses of
            some of the leading universities of India like, IIM Lucknow,
            Symbiosis Center for Management Studies and Symbiosis Law School are
            located here. It also houses branches of State Bank of India, HDFC
            Bank, ICICI Bank, IndusInd Bank and other prominent banks of India.
          </p>
          <br />
          <br />
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters to book your office space in Noida
          </h4>
          <p>
            GoFloaters has been in the space of helping individuals and teams
            find flexible and affordable workspaces for over 3 years now.
            GoFloaters was started with a vision to help anyone get an office
            space when they want, where they want and within their budget. We
            set out to build office spaces for a distributed world where
            individuals and teams should be able to work near home.
          </p>
          <br />
          <p>
            Following are the advantages of booking coworking spaces and meeting
            spaces on the GoFloaters app:
          </p>
          <ul>
            <li>
              <p>
                <strong>Work Near Home :</strong> In most of the cities that we
                serve you can get a space within 5 kms of your home or wherever
                you are
              </p>
            </li>
            <li>
              <p>
                <strong>Pay-per-use : </strong>You can book coworking spaces on
                a daily basis and meeting spaces on an hourly basis and pay only
                for the time you have used it.
              </p>
            </li>
            <li>
              <p>
                <strong>No contracts :</strong> You don&rsquo;t have to sign any
                kind of contracts with us.&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Cost effective :</strong> We have negotiated heavily
                with our space partners to bring you savings of at least 20% if
                not more on the day pass rates and the meeting room rents.
              </p>
            </li>
            <li>
              <p>
                <strong>Instant Bookings : </strong>No need to call anyone or
                email anyone to check space availability. You can book coworking
                spaces instantaneously. Meeting spaces just need 30 mins of time
                for confirmation.&nbsp;&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Community Perks :</strong> GoFloaters has partnered with
                over 65+ companies to bring you over Rs 1 Crore of benefits to
                you.
              </p>
            </li>
          </ul>
        </div>
      )
    case "Gurugram":
      return (
        <div className="col-md-12">
          <h4 style={{ fontWeight: "bold" }}>
            Top Office Space Locations in Gurugram
          </h4>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Udyog Vihar</h5>
          <p>
            Udyog Vihar is located near Delhi-Gurgaon Border and 8 km from
            Indira Gandhi International Airport on National Highways 8. The
            location is planned and well connected with roads. Rapid Metro rail
            is the most feasible transport option available. DLF Phase III is
            the nearest metro station to Udyog Vihar which is connected to
            Sikandarpur Metro Station, which further connects metro to different
            parts of Delhi and Gurgaon. Hyatt Place, The Leela, Trident Hotel,
            The Oberoi and Country Inn Carlson are some of the famous hotels
            near Udyog Vihar. It is one of the best locations for office space
            in Gurgaon.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Sector- 54</h5>
          <p>
            From the point of connectivity, Sector-54 chowk itself is a metro
            station, from where one can easily reach out to Delhi in just a few
            minutes. HCL healthcare clinic and Gmerk hospital is in the radius
            of 10 Kms. South point Mall, Fabindia and Sahara Mall are the
            all-time favorite hotspots for fun lovers and visitors. Also, the
            Suncity project in sector-54 offers a best residential premise as
            per your budget, if you are looking to settle down there. Sector-54
            well supports the co-working spaces in Gurgaon, meeting rooms and
            conference rooms.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Sector-48 &amp; 49</h5>
          <p>
            Both the sectors are known for its excellent education facilities
            including world class schools such as G.D. Goenka public school,
            Eden castle school, Budding minds, GEMS modern academy etc. The area
            has Merchant marine academy, E.C.H.S Polyclinic, Quest diagnostics
            and many more with world class medical facilities. If you are a
            foodie, you have the choice of Cyber adda 24, Mehfil Restaurant,
            Subway, the coriander, Colonel&rsquo;s kitchen and many more.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>DLF Cyber City</h5>
          <p>
            As the name suggests, Cyber city is the Cyber hub of big corporate
            and IT Industries from all over the world. This is a highly
            recommended location, if you are looking for office space for rent
            or shared office space or co-working space in Gurgaon. DLF Cyber
            city and Udyog Vihar are only 2-3 Kms. Apart from that, facilities
            are almost similar to those in Udyog Vihar. Presence of several
            companies in a small area makes this a busy part of the city.
          </p>
          <br />
          <br />
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters to book your office space in Gurgaon
          </h4>
          <p>
            GoFloaters has been in the space of helping individuals and teams
            find flexible and affordable workspaces for over 3 years now.
            GoFloaters was started with a vision to help anyone get an office
            space when they want, where they want and within their budget. We
            set out to build office spaces for a distributed world where
            individuals and teams should be able to work near home.
          </p>
          <br />
          <p>
            Following are the advantages of booking coworking spaces and meeting
            spaces on the GoFloaters app:
          </p>
          <ul>
            <li>
              <p>
                <strong>Work Near Home :</strong> In most of the cities that we
                serve you can get a space within 5 kms of your home or wherever
                you are
              </p>
            </li>
            <li>
              <p>
                <strong>Pay-per-use : </strong>You can book coworking spaces on
                a daily basis and meeting spaces on an hourly basis and pay only
                for the time you have used it.
              </p>
            </li>
            <li>
              <p>
                <strong>No contracts :</strong> You don&rsquo;t have to sign any
                kind of contracts with us.&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Cost effective :</strong> We have negotiated heavily
                with our space partners to bring you savings of at least 20% if
                not more on the day pass rates and the meeting room rents.
              </p>
            </li>
            <li>
              <p>
                <strong>Instant Bookings : </strong>No need to call anyone or
                email anyone to check space availability. You can book coworking
                spaces instantaneously. Meeting spaces just need 30 mins of time
                for confirmation.&nbsp;&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Community Perks :</strong> GoFloaters has partnered with
                over 65+ companies to bring you over Rs 1 Crore of benefits to
                you.
              </p>
            </li>
          </ul>
        </div>
      )
    case "Indore":
      return (
        <div className="col-md-12">
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters to book your office space in Indore
          </h4>
          <p>
            GoFloaters has been in the space of helping individuals and teams
            find flexible and affordable workspaces for over 3 years now.
            GoFloaters was started with a vision to help anyone get an office
            space when they want, where they want and within their budget. We
            set out to build office spaces for a distributed world where
            individuals and teams should be able to work near home.
          </p>
          <br />
          <p>
            Following are the advantages of booking coworking spaces and meeting
            spaces on the GoFloaters app:
          </p>
          <ul>
            <li>
              <p>
                <strong>Work Near Home :</strong> In most of the cities that we
                serve you can get a space within 5 kms of your home or wherever
                you are
              </p>
            </li>
            <li>
              <p>
                <strong>Pay-per-use : </strong>You can book coworking spaces on
                a daily basis and meeting spaces on an hourly basis and pay only
                for the time you have used it.
              </p>
            </li>
            <li>
              <p>
                <strong>No contracts :</strong> You don&rsquo;t have to sign any
                kind of contracts with us.&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Cost effective :</strong> We have negotiated heavily
                with our space partners to bring you savings of at least 20% if
                not more on the day pass rates and the meeting room rents.
              </p>
            </li>
            <li>
              <p>
                <strong>Instant Bookings : </strong>No need to call anyone or
                email anyone to check space availability. You can book coworking
                spaces instantaneously. Meeting spaces just need 30 mins of time
                for confirmation.&nbsp;&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Community Perks :</strong> GoFloaters has partnered with
                over 65+ companies to bring you over Rs 1 Crore of benefits to
                you.
              </p>
            </li>
          </ul>
          <br />
          <br />
          <h4 style={{ fontWeight: "bold" }}>Top office locations in Indore</h4>
          <p>
            <strong>Vijay Nagar</strong>
            <br />
            A prominent residential and commercial hub, Vijay Nagar is one of
            the most sought-after localities for offices in Indore. With wide
            roads, organized sectors and plenty of amenities, it has attracted
            companies from various sectors like IT, financial services,
            manufacturing etc. The availability of space and strong connectivity
            makes it suitable for all scales of business.
            <br />
            <br />
            <strong>Palasia</strong>
            <br />
            Palasia is the financial powerhouse of Indore with presence of
            banks, insurance companies and brokerage firms. The high street area
            also has premium office buildings, retail outlets and restaurants.
            With upcoming infra projects like the metro, Palasia continues to be
            central business district for traditional and new age companies
            alike.
            <br /> <br />
            <strong>RNT Marg</strong>
            <br />
            Located in Indore's business center, RNT Marg is home to many
            corporate offices, coworking spaces and IT companies. The
            connectivity and facilities available in RNT Marg and vicinity
            attracts professionals and entrepreneurs keen on accessibility. The
            area houses companies of all sizes - right from startups to major
            corporates.&nbsp;&nbsp;
            <br />
            <br />
            <strong>Scheme No. 54</strong>
            <br />
            With quality commercial and residential spaces, Scheme No. 54 has
            gained popularity among established companies and recent ventures
            alike. The affordability combined with facilities like banks, hotels
            etc. in proximity make it ideal for companies targeting value. Both
            glass buildings and independent floors provide quality options for
            office goers.&nbsp;&nbsp;
            <br /> <br />
            <strong>MG Road</strong>
            <br />
            As one of the most prominent commercial hubs with premium office
            spaces, retail outlets and recreation centers, MG Road is apt for
            major companies, banks and high end ventures looking to create an
            impression. The ambience combined with connectivity to all parts of
            Indore drive location preference despite relatively higher rents.
            <br />
          </p>
        </div>
      )
    default:
      return (
        <div className="col-md-12">
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters to book your office space in {props.city}
          </h4>
          <p>
            GoFloaters has been in the space of helping individuals and teams
            find flexible and affordable workspaces for over 3 years now.
            GoFloaters was started with a vision to help anyone get an office
            space when they want, where they want and within their budget. We
            set out to build office spaces for a distributed world where
            individuals and teams should be able to work near home.
          </p>
          <br />
          <p>
            Following are the advantages of booking coworking spaces and meeting
            spaces on the GoFloaters app:
          </p>
          <ul>
            <li>
              <p>
                <strong>Work Near Home :</strong> In most of the cities that we
                serve you can get a space within 5 kms of your home or wherever
                you are
              </p>
            </li>
            <li>
              <p>
                <strong>Pay-per-use : </strong>You can book coworking spaces on
                a daily basis and meeting spaces on an hourly basis and pay only
                for the time you have used it.
              </p>
            </li>
            <li>
              <p>
                <strong>No contracts :</strong> You don&rsquo;t have to sign any
                kind of contracts with us.&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Cost effective :</strong> We have negotiated heavily
                with our space partners to bring you savings of at least 20% if
                not more on the day pass rates and the meeting room rents.
              </p>
            </li>
            <li>
              <p>
                <strong>Instant Bookings : </strong>No need to call anyone or
                email anyone to check space availability. You can book coworking
                spaces instantaneously. Meeting spaces just need 30 mins of time
                for confirmation.&nbsp;&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Community Perks :</strong> GoFloaters has partnered with
                over 65+ companies to bring you over Rs 1 Crore of benefits to
                you.
              </p>
            </li>
          </ul>
        </div>
      )
  }
}

export function OfficeContentLocality(props) {
  switch (props.city) {
    case "Bengaluru":
      if (props.locality === "HSR Layout")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Office Spaces in HSR Layout, {props.city}
            </h4>
            <p>
              HSR layout is a very developed and modern area, abundant with
              coworking spaces, hotdesks and monthly office spaces on rent. This
              means there will, without a doubt, be a space that is the ideal
              match for any and every individual’s specific and particular
              needs!
              <br />
              <br />
              For companies of all sizes, GoFloaters helps you with flexible
              spaces for monthly rent. Find the office spaces in HSR that's best
              for you.
              <br />
              <br />
            </p>
          </div>
        )
      if (props.locality === "Kadubeesanahalli")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Office Spaces in Kadubeesanahalli, {props.city}
            </h4>
            <p>
              Kadubeesanahalli, located strategically in Bengaluru's bustling
              tech corridor, stands out as a focal point for contemporary office
              solutions. With its close proximity to major IT hubs, the locale
              has seen a surge in state-of-the-art coworking venues, individual
              desks, and monthly office rentals. Whether you're a startup
              finding its footing, a freelancer looking for a productive
              environment, or an established enterprise aiming to expand,
              Kadubeesanahalli offers spaces that can be tailored to every
              specific need.
              <br />
              <br />
              For businesses across the spectrum, GoFloaters is your partner in
              discovering flexible workspace solutions. Dive into the plethora
              of office spaces in Kadubeesanahalli, Bengaluru, and find the one
              that aligns with your vision.
              <br />
              <br />
            </p>
          </div>
        )
      if (props.locality === "Whitefield")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Office Spaces in Whitefield, {props.city}
            </h4>
            <p>
              Whitefield, Bengaluru is a bustling tech hub, brimming with
              cutting-edge office spaces, coworking zones, and monthly rental
              solutions. This ensures that anyone, regardless of their unique
              requirements, can find a space that's a perfect fit!
              <br />
              <br />
              For businesses ranging from startups to established enterprises,
              GoFloaters is your go-to for flexible monthly rental options.
              Discover the shared office spaces in Whitefield that align with
              your aspirations.
              <br />
              <br />
            </p>
          </div>
        )
      if (props.locality === "Koramangala")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Office Spaces in Koramangala, {props.city}
            </h4>
            <p>
              Koramangala is home to several IT companies and colleges. Catering
              to this youthful, intelligent and boisterous energy it has
              expanded into one of the coolest neighbourhoods in Bangalore. With
              the best restaurants, posh neighbourhoods and an abundance of
              activities to engage in it offers the best facilities and
              environment for enhanced productivity.
              <br />
              <br />
              This is evident from the amalgam of startups that have emerged and
              achieved incredible success in Koramangala. These startups include
              - Lookup, Instamojo, Explara, Furlenco, HackerEarth and many more.
              <br />
              <br />
              It is no wonder that Koramangala has innumerable coworking spaces.
              The hotdesks offered here are designed to provide the optimal
              balance between communal working to facilitate the ebb and flow of
              ideas with the privacy and peaceful silence to work effectively
              away from home. Most entrepreneurs start their ventures out of
              coworking spaces, as this is a more economical option in
              comparison to leasing office space. Koramangala with its wide
              range of options, has coworking spaces for all budgets and
              expectations.
              <br />
              <br />
              In addition to this, its high connectivity to the rest of
              Bangalore makes it an ideal place to work and host meetings.
              <br />
              <br />
            </p>
            <h4 style={{ fontWeight: "bold" }}>
              Why Choose GoFloaters To Book Your Office Space Needs in
              Koramangala, Bengaluru
            </h4>
            <p>
              Imagine having the freedom to work where you want, when you want,
              and all within your budget. That's precisely what GoFloaters
              offers you in the heart of Koramangala, Bengaluru.&nbsp;
              <br />
              <br />
              Here are the compelling reasons why you should choose GoFloaters
              to book your coworking spaces and{" "}
              <a href="https://gofloaters.com/meeting-spaces/bengaluru/koramangala">
                meeting rooms in Koramangala
              </a>
              :
              <br />
              <br />
              <strong>1. Work Near Home:</strong> In Koramangala, just like in
              the other cities we serve, you can find a workspace within a mere
              5 kilometers of your residence or wherever you happen to be. We
              understand the value of reducing your commute and making your
              work-life balance more attainable.
              <br />
              <br />
              <strong>2. Pay-Per-Use Flexibility:</strong> With GoFloaters,
              you're in control. You can{" "}
              <a href="https://gofloaters.com/blog/office-for-a-month/">
                book coworking spaces
              </a>{" "}
              on a daily basis and meeting rooms by the hour, ensuring you pay
              only for the time you actually use. No more paying for office
              space when you're not even there.
              <br />
              <br />
              <strong>3. No Contracts, No Hassles:</strong> Forget about signing
              binding contracts. We believe in flexibility, and we give it to
              you. You're not tied down by lengthy agreements or commitments, so
              you have the freedom to adapt to your changing workspace needs.
              <br />
              <br />
              <strong>4. Cost-Effective Solutions:</strong> We've worked
              tirelessly with our space partners to bring you unbeatable
              savings. When you book through GoFloaters, you can enjoy discounts
              of at least 20% or more compared to standard day pass rates and
              meeting room rentals. We want to help you save while enjoying
              top-notch office facilities.
              <br />
              <br />
              <strong>5. Instant Bookings:</strong> Say goodbye to the hassles
              of calling or emailing to check space availability. With
              GoFloaters, you can secure coworking spaces instantly with just a
              few clicks. Meeting spaces require a mere 30 minutes for
              confirmation, giving you the efficiency you need for your busy
              workday.
              <br />
              <br />
              So, if you're ready to revolutionize the way you work in
              Koramangala, Bengaluru, GoFloaters is your ideal partner.&nbsp;
              <br />
              <br />
              Experience the freedom, convenience, and affordability of our
              coworking and meeting spaces today. Make your workspace work for
              you, right here with GoFloaters.
              <br />
            </p>
          </div>
        )
      if (props.locality === "Indiranagar")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Office Spaces in Indiranagar, {props.city}
            </h4>
            <p>
              Indiranagar is a stylish and exclusive neighbourhood, located in
              East Bangalore. Every street is immersed in colour, life and
              vibrance with their restaurants, shops and boutiques. It serves as
              a base for several premier Indian and International brands.
              <br />
              <br />
              Indiranagar being a posh area, offers the best of services and
              amenities. This makes it an ideal place to work. There is an
              impressive collection of corporate offices for famous companies in
              and around Indiranagar including Dunzo, Boeing, HSBC, HP, Dell,
              LinkedIn, IBM, Oracle and many more!
              <br />
              <br />
              With its enumerable IT companies, universities and tech parks, it
              has spectacular infrastructure and is miles ahead of other
              localities in terms of technological advancements and hospitality
              offered.
              <br />
              <br />
              Indiranagar is very well connected, thanks to the metro line and
              100 Feet Road. This makes it very convenient and accessible for
              commuters.
              <br />
              <br />
              Countless coworking spaces with refined corporate setting, privacy
              and comforting ambience are found here. Working in Indiranagar is
              nothing short of paradise.
              <br />
              <br />
            </p>
          </div>
        )
    case "Mumbai":
      if (props.locality === "Andheri")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Office Spaces in Andheri, {props.city}
            </h4>
            <p>
              Cool places to work from Andheri
              <br />
              <br />
              Andheri is a huge suburb in western Mumbai consisting of premium
              residential, commercial and financial areas. The demand of this
              area has increased in the past few years due to the expansion of
              the metro rail in Mumbai, improving its potential as one of the
              prime locations of Mumbai.
              <br />
              <br />
              <b>Location:</b> Andheri is located in the western part of the
              city. Divided by the Mumbai local railways, it is divided in
              Andheri West and Andheri East with each having their distinct
              characteristics. Andheri west has become a sought after
              residential area with posh locations like sea facing Versova and
              busy commercial markets in Lokhandwala. Andheri east is full of
              commercial establishments with proximity to industrial and export
              processing zones and the airport.
              <br />
              <br />
              <b>Facilities:</b> Andheri offers a myriad of things to do,
              professionally and recreationally. It has a lot of corporate
              offices, banks, retail and entertainment hubs, hospitals, schools,
              restaurants. It is also home to some of the biggest entertainment
              production houses creating ample job opportunities with constant
              need for office space. There are accommodations available which
              are suitable for all budgets.
              <br />
              <br />
              <b>Infrastructure:</b> Andheri is a major transportation hub. With
              easy access to public transport like Mumbai metro, local trains,
              bus and rickshaw, Andheri is an excellent locality for any
              commercial purpose. It has good road connectivity with other parts
              of the city.
              <br />
              <br />
            </p>
          </div>
        )
      if (props.locality === "Powai")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Office Spaces in Powai, {props.city}
            </h4>
            <p>
              Powai, Mumbai stands as a dynamic urban epicenter, teeming with
              shared office environments, collaborative work zones, and monthly
              rental opportunities. This guarantees that every professional,
              irrespective of their distinct preferences, will pinpoint a
              workspace that resonates with their vision!
              <br />
              <br /> For ventures from budding startups to sprawling
              corporations, GoFloaters is your reliable partner for versatile
              monthly leasing solutions. Explore the shared office spaces in
              Powai that synchronize with your ambitions.
              <br />
              <br />
            </p>
          </div>
        )
      if (props.locality === "Santacruz West")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Office Spaces in Santacruz West, {props.city}
            </h4>
            <p>
              Santacruz is a western suburb of Mumbai, and home to International
              and domestic airports. The location enjoys excellent connectivity
              to all parts of the city via the expressway, Mumbai Suburban
              Railway Lines, and the Mumbai Metro. Some of the things that make
              this a popular destination to live and work include:
              <br />
              <br />
              <b>Centrally located:</b> Santacruz is located between the upscale
              residential suburb of Juhu, Vileparle, and Khar. Proximity to the
              Airport and Highways makes Santacruz one is the premium suburb of
              Mumbai geographically. Import and export trade businesses have
              offices near the airport. The location has become the link for
              accessing the central suburbs of Mumbai via the SCLR expressways.
              Proximity to the business hub BKC is another added advantage for
              the location.
              <br />
              <br />
              <b>Facilities:</b> Santacruz offers abundant opportunities to
              maintain a good lifestyle and healthy work-life balance. The
              location offers a wide variety of commercial establishments,
              recreational activities, entertainment options, educational
              institutions. Corporate headquarters of many banks, fashion
              brands, upscale retail outlets are located here.
              <br />
              <br />
              <b>Infrastructure:</b> Santacruz has industrial processing areas
              like SEEPZ, premium retail outlets of high fashion houses,
              educational institutions like SNDT College and the University of
              Mumbai. There is excellent connectivity to other parts of the city
              through a robust rail network and road connections. Numerous
              skywalks have been made for easy pedestrian flow.
              <br />
              <br />
            </p>
          </div>
        )
    case "Pune":
      if (props.locality === "Koregaon Park")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Discover Shared Office Spaces in Koregaon Park, Pune with
              GoFloaters
            </h4>
            <p>
              Are you on the lookout for shared office spaces in Pune?
              GoFloaters offers an exceptional selection tailored to meet your
              professional needs. These shared offices combine modern amenities,
              a collaborative atmosphere, and prime locations throughout Pune.
              Perfect for startups, freelancers, and established companies,
              GoFloaters' shared spaces provide the flexibility and scalability
              crucial for thriving in today's fast-evolving business landscape.{" "}
              <br />
              <br />
            </p>
          </div>
        )
      if (props.locality === "Baner")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Office Spaces in Baner, {props.city}
            </h4>
            <p>
              Baner is a popular suburb in Pune. Pune is one of the heavily
              industrialised zones in the country that have many workspaces and
              other Office Spaces in and around the area to accommodate the
              workforce that lives in the city.
              <br />
              <br />
              Located in the Western Corridor of Pune, Baner is home to some of
              the biggest manufacturing units of automobiles and other various
              goods. It also comprises many IT companies and other firms that
              have their headquarters in the area. A new rise in the number of
              co-working spaces has made it better for the people who work in
              the area to use the facilities and work remotely from the place of
              their choice.
              <br />
              <br />
              These Office Spaces in Baner have many facilities that they
              provide for the people. Facilities such as fast Wi-Fi, freshly
              brewed coffee, projector rooms, TVs for presentations, dedicated
              meeting rooms and hot desks. They provide everything and you will
              have to pay by the hour or per day, depending on your usage.
              <br />
              <br />
              Co-working spaces in the Magarpatta city, Cybercity, Ashok Chakra
              circle and many other places help people who live and work in and
              around the area to choose the coworking space of their choice and
              lets them work remotely with all the available facilities they
              require for working during the day and night. If you want to know
              where you can book such spaces, head over to GoFloaters and choose
              the coworking space of your choice now. <br />
              <br />
            </p>
          </div>
        )
      if (props.locality === "Viman Nagar")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Office Spaces in Viman Nagar, {props.city}
            </h4>
            <p>
              Viman Nagar is an affluent residential and retail neighbourhood in
              the Eastern Metropolitan Corridor of Pune and serves as one of the
              most prominent regions in the city. It is in proximity to the Pune
              International Airport. Viman Nagar is very close to Pune airport.
              This is the main reason behind its name, because of the
              near-airport the rates of real-estate are very high in Viman Nagar
              compared to the entire Pune district. Besides this, many companies
              like Tech Mahindra, Viera Tech, Indigo Architects, Ericsson Global
              India Services Pvt Ltd, etc are in the area which caters to 1000s
              of people working in the area. Office Spaces in this area are
              thriving and they almost get many people who work in here to their
              spaces almost every day. These coworking spaces also provide some
              of the best in class facilities they can offer to a person. They
              provide the fastest Wi-Fi possible, hot desks, private meeting
              rooms to have meetings and discussions, TVs for presentations,
              projectors and many more things that are required for a suitable
              working space remotely. With these coworking spaces, individuals
              get a lot of perspectives and help with their growth as well. If
              you want such spaces, then head over to GoFloaters and choose the
              space of your choice. <br />
              <br />
            </p>
          </div>
        )
    case "Kolkata":
      if (props.locality === "AJC Bose Road")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Office Spaces in AJC Bose Road, {props.city}
            </h4>
            <p>
              Acharya Jagadish Chandra Bose Road, earlier known as Lower
              Circular Road, and its continuation northwards called Acharya
              Prafulla Chandra Road (Upper Circular Road), is the longest and
              the most important north-south thoroughfare in Kolkata, India. It
              houses the Steel Authority of India, The Times of India and many
              other companies that are present in the area. Most of these spaces
              have coworking spaces that provide the usual facilities that are
              provided by most of the coworking spaces across the city. They
              provide the fastest Wi-Fi possible, hot desks, private meeting
              rooms to have meetings and discussions, TVs for presentations,
              projectors, etc. Although there are government offices in this
              area it is not as famous for coworking spaces, but people still
              use it for meetings and many other things. These places also
              include some of the best eateries that are available in the entire
              city of Kolkata. There are many modern as well as old stores that
              sell things that are of interest to everybody that visit these
              places. To choose one of these spaces head over to GoFloaters and
              book the space now.
              <br />
              <br />
            </p>
          </div>
        )
      if (props.locality === "Park Street")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Office Spaces in Park Street, {props.city}
            </h4>
            <p>
              Park Street, officially known as Mother Teresa Sarani, is a famous
              thoroughfare in downtown Kolkata (formerly Calcutta), India. The
              street runs through what was a deer park of Sir Elijah Impey,
              Chief Justice of the Supreme Court in Calcutta from 1773 to 1789,
              hence the earlier name. Kolkata Municipal Corporation gave its
              current official name in honour of Mother Teresa. It’s in Central
              Kolkata. Park Street is home to the famous Football Club, Mohun
              Bagan FC, Cisco Systems, Wonderland and many other companies that
              are placed in this street use coworking spaces regularly. Since
              the rise of COVID, there has been a complete shift to working from
              home and the remote working space has seen an immense rise in its
              usage by many across the city. These spaces offer some of the best
              facilities that money can hire for a short period. Remote working
              is a concept that has been there for a while and it will be on the
              increase for the coming years. They provide the fastest Wi-Fi
              possible, hot desks, private meeting rooms to have meetings and
              discussions, TVs for presentations, projectors, etc. If you want
              to choose the space for yourself or the day, go to the GoFloaters
              application and book the space of your choice at your convenience
              and then show up to avail of some of the best facilities.
              <br />
              <br />
            </p>
          </div>
        )
    case "Ahmedabad":
      if (props.locality === "Vadodara")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Office Spaces in Vadodara, {props.city}
            </h4>
            <p>
              Over 2.2 million people work here and there is only one place that
              all of them call home VADODARA! From being a retired people’s
              paradise to a college-going students’ hub, this city is one of the
              most diverse places in INDIA. It is also known as the cultural
              capital of Gujarat. Let us take a look at how this city has
              expanded over the years.
              <br />
              <br />
              There are a bunch of coworking and remote working spaces in and
              around Vadodara. Recently after the lockdown and the multiple
              covid waves, offices have decided to make sure that their
              employees are working from a proper place. They have then resorted
              to renting out coworking spaces across the city that is suitable
              for them and making sure that their people work from there. THE
              CO•WORK CAPITAL is one such place where co-working and remote
              working is highly promoted. Its nearness to the Notus IT park is a
              huge advantage for people who work in the IT Park.
              <br />
              <br />
              Most co-working spaces today have all the facilities that are
              required to meet the standards of modern-day users. Enjoy the
              uninterrupted working experience with high-speed internet and
              power backup. There is a whiteboard available for you to
              brainstorm and take notes on. Share your screen on the LED TV in
              the room. Share your screen on the projector in the room to enable
              your discussion. When you need to take a break there are
              refreshments available in the pantry. Free parking is available on
              a first-come first-serve basis. Copier and printer are also
              available for your work needs.
              <br />
              <br />
              With modern-day technologies that are provided in the coworking
              spaces across the city and many more things that are attached to
              these spaces it makes for a wonderful working experience. You can
              book these spaces at Rs 700 / hr. It is also available on a daily
              basis at Rs 6000 / day.
              <br />
              <br />
            </p>
          </div>
        )
    case "Madurai":
      if (props.locality === "")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>Office Spaces in Madurai</h4>
            <p>
              Madurai, the ancient and vibrant city is known as Thoonga Nagaram-
              'the sleepless city of India'. This is because the city is always
              swarmed with activities and 24 hours seems less. All day and night
              businesses, industries and various institutions keep the city
              awakened.
              <br />
              <br />
              Over the years, in addition to the historic reference to the city,
              Madurai has become one of the top locations for coworking and
              flexible work oppportunities. Even with limited options, Madurai
              still has some of the best Office Spaces in the region. In the
              last couple of years the city has seen a large reverse migrated
              population. The workforce are returning back to their hometowns.
              Entrepreneurial ventures, startups, IT and ITes professionals are
              getting home or finding their way back to Madurai to live in this
              agrarian and heritage city.
              <br />
              <br />
              Madurai is a major Tier II region for IT and Industry.
              <br />
              <br />
              Kapalua, which is a sub-urban of Madurai, is a business hub for
              automotive industries such as KUN BMW, Isuzu, Volkswagen, Toyota,
              Mahindra, Tata, Maruti Suzuki, Mitsubishi, Ashok Leyland, Jeep,
              Fiat India (FCA). Apart from these manufacturing units, there are
              many IT companies that have setup their offices in the city. There
              are around 5 co-working spaces in easily approachable locations
              and in and around the Meenakshi Amann Temple. <br />
              <br />
              There are many facilities that these spaces have. Fast Wi-fi,
              freshly brewed coffee from some of the finest restaurants being
              served to everybody, TVs, Projectors, Meeting rooms, dedicated
              parking spots, cubicles, hot desks and many more. <br />
              <br />
              Distributed remote hubs are common in Madurai. In the recent past,
              the city has also attracted many remote workers along with
              tourism, which has always been in full swing. This makes Madurai
              and ideal tranquil locations to work from anywhere with co-work
              and meeting spaces. In an ideal setting, making that impression
              during your meeting is especially important–be it within the team
              or with clientele. From a 2-person meeting room to 10+ seater
              meeting room, at GoFloaters you can find the perfect venue to make
              your meetings constructive and significant.
              <br />
              <br />
            </p>
          </div>
        )
    case "Visakhapatnam":
      if (props.locality === "")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Office Spaces in Visakhapatnam
            </h4>
            <p>
              Visakhapatnam is a port city and industrial centre in the Indian
              state of Andhra Pradesh, on the Bay of Bengal. It’s known for its
              many beaches, including Ramakrishna Beach, home to a preserved
              submarine at the Kusura Submarine Museum. Nearby are the elaborate
              Kali Temple and the Visakha Museum, an old Dutch bungalow housing
              local maritime and historical exhibits.
              <br />
              <br />
              Waltair Main Road, Gurudwara Road and many more across the city
              has amazing coworking spaces which are used by a lot of IT
              professionals living and working in the city. They are easily
              accessible and have a lot of things to do in and around these
              areas, which is beneficial for the employees of the company.{" "}
              <br />
              <br />
              Being an IT Hub is difficult for any city. Just like that, Vizag
              has a lot of places where it is friendly to work from anywhere and
              make sure that there is no problem in doing so! These places are
              so efficient that you can use applications like GoFloaters to make
              or book a personalized space of your choice that you want at ease.
              These places have the best in class facilities such as TVs, Wi-Fi,
              and coffee that will keep you going throughout the day. Apart from
              the usual, they also have dedicated meeting rooms, hot desks and
              many other facilities that will help you connect, work and gain a
              different perspective in your work. <br />
              <br />
              To facilitate IT employees working from remote locations,
              Information Technology Minister Mekapati Goutham Reddy recently
              launched a State government’s Work from Hometown (W@HT) website.
              With W@HT centres across the State, the government aims to provide
              proper infrastructures, such as high-speed internet, uninterrupted
              power supply and dedicated work spaces, to IT and ITES employees/
              employers and freelancers who are working from home due to the
              Covid- 19 pandemic.
              <br />
              <br />
            </p>
          </div>
        )
    case "Lucknow":
      if (props.locality === "Gomti Nagar")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Office spaces in Gomti Nagar, Lucknow
            </h4>
            <p>
              Emerging as Lucknow's premier corporate and residential hub, Gomti
              Nagar houses a mix of commercial developments catering to diverse
              business needs. From boutique offices for startups and SMEs to
              Grade A buildings for large corporates, Gomti Nagar provides
              quality workspaces across budgets.
              <br />
              <br />
              The independent plots and low-rise developments offer budget
              conscious companies own commercial setups with flexibility. Many
              of the high street spaces also get converted into co-working
              offices providing shared amenities and networking opportunities.
              For bigger headcount needs, Gomti Nagar has integrated IT and
              business parks with studios to private cabins along with
              facilities.
              <br />
              <br />
              Being well-planned with wide roads and regulated construction,
              companies here can expect good connectivity and infrastructure
              support. The availability of housing, malls and hospitals in
              proximity also attracts companies looking to improve employee
              experience. Easy access from Shaheed Path and Sultanpur road is an
              added advantage over congested central business districts.
              <br />
              <br />
              Between its green avenues and modern buildings, Gomti Nagar allows
              companies to build their own corporate identity with workspaces
              that reflect culture and values. The area houses names across
              sectors - from IT giants like HCL Technologies to news channels
              and medical device companies. With lucknow developing into an
              emerging IT hub, Gomti Nagar promises to be at the centre of its
              growing formal economy.
              <br />
              <br />
            </p>
          </div>
        )
    case "Chandigarh":
      if (props.locality === "")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>Office Spaces in Chandigarh</h4>
            <p>
              Chandigarh is the capital of the state of Punjab where there are
              many prosperous industries and prominent companies that are
              present in the country. The state is rich for its diversity and
              the number of people it serves. It is also the capital of one of
              the 2 neighbouring states of Punjab and Haryana. With the increase
              of these industries and companies there has been a sharp increase
              in the Office Spaces in Chandigarh.
              <br />
              <br />
              Chandigarh is home to some of the best companies that India has
              ever produced. The city houses Webdew, Tech Mahindra, Infosys,
              IndiSoftware and many more. Keeping this in mind there are many
              Office Spaces in Chandigarh where people from the offices can use
              these spaces to run meetings outside of the workspace and many
              more. The co-working spaces in Chandigarh are located in prominent
              localities such Chandi Path, SDM Office Road, And near Butterfly
              park. <br />
              <br />
              Many of these locations have some of the best facilities that are
              there to provide. Fast Wi-Fi, TV’s for presentations, meeting
              spaces, dedicated hot desks, and many more. The Office Spaces in
              Chandigarh have a very nice ambience to them and they always make
              sure it is proper and correct at all times. These amenities also
              make it suitable as the Meeting Spaces on rent by the day or hour
              in Chandigarh.
              <br />
              <br />
              The startup culture in Chandigarh is picking up pace and due to
              COVID these last 2 years have been a blur in that increase. There
              are so many companies that completely moved to working from home
              and they have moved to working remotely. Companies like Simba
              Beer, Viprasoft and Just Herbs have completely moved to working
              from home and their employees use the meeting spaces or Office
              Spaces in Chandigarh at their own convenience. To book such
              coworking spaces in Chandigarh head over to the GoFloaters page
              and book now.
              <br />
              <br />
            </p>
          </div>
        )
    case "Nagpur":
      if (props.locality === "")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>Office Spaces in Nagpur</h4>
            <p>
              Nagpur is the third-largest city in India and the winter capital
              of Maharashtra. It is the 13th largest city in India by
              population. Nagpur is an emerging metropolis. Nagpur's nominal GDP
              was estimated to be around ₹ 1,406,860 million in 2019-20, making
              it the largest economic centre in entire central India. Nagpur has
              many industries and startups that provide jobs to many in and
              around the city. It is home to the most famous snack manufacturer
              Haldirams. Nagpur is an upcoming 'smart city' of India. <br />
              <br />
              There are many Office Spaces in Nagpur mainly because there are
              many companies that have started or shifted to working remotely
              completely. Companies such as Prominent Information Technology
              companies such as TCS, Tech Mahindra, HCL, GlobalLogic, Persistent
              Systems and Hexaware are located at various IT parks in Nagpur.
              Since these companies have shifted to working from home, coworking
              spaces have thrived. Places such as Nehru Marg, Bus Stand Road,
              Narrow Guage Rail Museum and other places have coworking spaces
              located near them which is easily accessible for many people who
              work in the area.
              <br />
              <br />
              The corporate shift to hybrid and remote work models has made
              Nagpur, a sought after location for coworking. Coworking players
              are eyeing the Tier 2 & 3 cities such as Nagpur to double their
              space for coworking in Nagpur and providing meeting space in
              Nagpur. <br />
              <br />
              The workspaces have best of amenities required for individual,
              working, meeting teams' or pitch presentation or casual day of
              work. <br />
              <br />
              Nagpur is the educational and commercial hub of the region. The
              city gets massive support for innovations via grants and
              opportunities from the State Government of Maharashtra. <br />
              <br />
              Saas, Foodtech, Edtech, and Manufacturing are some of the
              industries that are being explored by the startup and young
              entrepreneurs of Nagpur.
              <br />
              <br />
              Nagpur is also now slowly transforming into an ideal destination
              for independent consultants and freelancers with its idyllic
              location and lower cost of living when compared to urban cities.{" "}
              <br />
              <br />
              Coworking and remote working spaces in Nagpur seem to provide
              networking opportunity and ambiance to ideate and innovate further
              for the developments. <br />
              <br />
              So, if you want to book an inspirational space to cowork in
              Nagpur, then GoFloaters is the right choice for you. Log in to the
              application and choose the space of your choice today.
            </p>
          </div>
        )
    case "New Delhi":
      if (props.locality === "Connaught Place")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Office Spaces in Connaught Place, New Delhi
            </h4>
            <p>
              Connaught Place, often referred to as the heart of New Delhi, is a
              bustling hive of activity and one of the city's most prestigious
              and vibrant commercial and business centers. With its array of
              top-tier restaurants, high-end shops, and cultural hotspots,
              Connaught Place offers an unparalleled environment for businesses
              seeking to thrive amidst the city's dynamic pulse.
              <br />
              <br />
              Office spaces in Connaught Place are as diverse as the businesses
              they house. From traditional office buildings to modern coworking
              spaces, there is something for every type of business. The
              coworking spaces here are particularly notable for their blend of
              style and functionality, offering everything from private offices
              to collaborative workspaces. These spaces are designed to foster
              creativity and productivity, providing a perfect balance between
              the buzz of communal working and the necessity for quiet, focused
              work areas.
              <br />
              <br />
              Moreover, the excellent connectivity of Connaught Place to the
              rest of Delhi, through an efficient network of roads and the
              metro, adds to its appeal as a prime business location. Its
              central position makes it incredibly convenient for hosting
              meetings, networking events, and accessing the myriad of amenities
              the city has to offer.
              <br />
              <br />
            </p>
          </div>
        )
    case "Hyderabad":
      if (props.locality === "Gachibowli")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Office spaces in Gachibowli, Hyderabad
            </h4>
            <p>
              Gachibowli has emerged as the new IT and financial hub of
              Hyderabad with several high-rises and tech parks housing many
              major companies. While the western part boasts of large corporate
              offices and special economic zones, eastern Gachibowli is seeing
              growth of co-working spaces, boutique offices and startups. Office
              spaces in Gachibowli cater to this diverse business landscape.
              <br />
              <br />
              For larger enterprises and MNCs, there are spacious commercial
              buildings and campuses with state-of-the-art facilities for their
              workforce. Many also opt for sleek corporate offices in the
              integrated business districts which offer employee amenities like
              food courts, banks and shuttle services. Startups and smaller
              firms can tap into shared workspaces and plug-and-play offices
              that provide flexibility along with networking opportunities.
              <br />
              <br />
              These contemporary co-working spaces fuse work and leisure with
              cafés, lounges and collaboration areas. Located in the vicinity of
              Hi-tech city, Gachibowli offers workspaces merging productivity
              and convenience. Professionals can easily access facilities like
              gyms, day-cares and hotels without the grind of long commutes.
              Well-connected by public transport and the Outer Ring Road, office
              spaces in Gachibowli let the workforce stay connected to the rest
              of city while enjoying the self-sufficient ecosystem the area
              provides.
              <br />
              <br />
            </p>
          </div>
        )
    default:
      return <div className="col-md-12"></div>
  }
}
